export const COUNTRY = {
    IN: "IN",
    US: "US",
    SG: "SG",
    IL: 'IL',
    MY: "MY"
}

export const Countries = [
    {
        label: 'Afghanistan',
        currencyCode: 'AFN',
        value: 'AF',
        dial_code: '+93',
        timezone: 'UTC+04:30'
    },
    {
        label: 'Åland Islands',
        currencyCode: 'EUR',
        value: 'AX',
        dial_code: '+358',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Albania',
        currencyCode: 'ALL',
        value: 'AL',
        dial_code: '+355',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Algeria',
        currencyCode: 'DZD',
        value: 'DZ',
        dial_code: '+213',
        timezone: 'UTC+01:00'
    },
    {
        label: 'American Samoa',
        currencyCode: 'USD',
        value: 'AS',
        dial_code: '+1684',
        timezone: 'GMT-11:00'
    },
    {
        label: 'Andorra',
        currencyCode: 'EUR',
        value: 'AD',
        dial_code: '+376',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Angola',
        currencyCode: 'AOA',
        value: 'AO',
        dial_code: '+244',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Anguilla',
        currencyCode: 'XCD',
        value: 'AI',
        dial_code: '+1264',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Antarctica',
        currencyCode: 'AUD',
        value: 'AQ',
        dial_code: '+672',
        timezone: 'GMT-03:00'
    },
    {
        label: 'Antigua and Barbuda',
        currencyCode: 'XCD',
        value: 'AG',
        dial_code: '+1268',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Argentina',
        currencyCode: 'ARS',
        value: 'AR',
        dial_code: '+54',
        timezone: 'GMT-03:00'
    },
    {
        label: 'Armenia',
        currencyCode: 'AMD',
        value: 'AM',
        dial_code: '+374',
        timezone: 'UTC+04:00'
    },
    {
        label: 'Aruba',
        currencyCode: 'AWG',
        value: 'AW',
        dial_code: '+297',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Australia',
        currencyCode: 'AUD',
        value: 'AU',
        dial_code: '+61',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Austria',
        currencyCode: 'EUR',
        value: 'AT',
        dial_code: '+43',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Azerbaijan',
        currencyCode: 'AZN',
        value: 'AZ',
        dial_code: '+994',
        timezone: 'UTC+04:00'
    },
    {
        label: 'Bahamas',
        currencyCode: 'BSD',
        value: 'BS',
        dial_code: '+1242',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Bahrain',
        currencyCode: 'BHD',
        value: 'BH',
        dial_code: '+973',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Bangladesh',
        currencyCode: 'BDT',
        value: 'BD',
        dial_code: '+880',
        timezone: 'UTC+06:00'
    },
    {
        label: 'Barbados',
        currencyCode: 'BBD',
        value: 'BB',
        dial_code: '+1246',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Belarus',
        currencyCode: 'BYN',
        value: 'BY',
        dial_code: '+375',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Belgium',
        currencyCode: 'EUR',
        value: 'BE',
        dial_code: '+32',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Belize',
        currencyCode: 'BZD',
        value: 'BZ',
        dial_code: '+501',
        timezone: 'GMT-06:00'
    },
    {
        label: 'Benin',
        currencyCode: 'XOF',
        value: 'BJ',
        dial_code: '+229',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Bermuda',
        currencyCode: 'BMD',
        value: 'BM',
        dial_code: '+1441',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Bhutan',
        currencyCode: 'BTN',
        value: 'BT',
        dial_code: '+975',
        timezone: 'UTC+06:00'
    },
    {
        label: 'Bolivia (Plurinational State of)',
        currencyCode: 'BOB',
        value: 'BO',
        dial_code: '+591',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Bonaire, Sint Eustatius and Saba',
        currencyCode: 'USD',
        value: 'BQ',
        dial_code: '+5997',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Bosnia and Herzegovina',
        currencyCode: 'BAM',
        value: 'BA',
        dial_code: '+387',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Botswana',
        currencyCode: 'BWP',
        value: 'BW',
        dial_code: '+267',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Bouvet Island',
        currencyCode: 'NOK',
        value: 'BV',
        dial_code: '+',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Brazil',
        currencyCode: 'BRL',
        value: 'BR',
        dial_code: '+55',
        timezone: 'GMT-05:00'
    },
    {
        label: 'British Indian Ocean Territory',
        currencyCode: 'USD',
        value: 'IO',
        dial_code: '+246',
        timezone: 'UTC+06:00'
    },
    {
        label: 'United States Minor Outlying Islands',
        currencyCode: 'USD',
        value: 'UM',
        dial_code: '+',
        timezone: 'GMT-11:00'
    },
    {
        label: 'Virgin Islands (British)',
        currencyCode: null,
        value: 'VG',
        dial_code: '+1284',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Virgin Islands (U.S.)',
        currencyCode: 'USD',
        value: 'VI',
        dial_code: '+1 340',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Brunei Darussalam',
        currencyCode: 'BND',
        value: 'BN',
        dial_code: '+673',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Bulgaria',
        currencyCode: 'BGN',
        value: 'BG',
        dial_code: '+359',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Burkina Faso',
        currencyCode: 'XOF',
        value: 'BF',
        dial_code: '+226',
        timezone: 'GMT'
    },
    {
        label: 'Burundi',
        currencyCode: 'BIF',
        value: 'BI',
        dial_code: '+257',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Cambodia',
        currencyCode: 'KHR',
        value: 'KH',
        dial_code: '+855',
        timezone: 'UTC+07:00'
    },
    {
        label: 'Cameroon',
        currencyCode: 'XAF',
        value: 'CM',
        dial_code: '+237',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Canada',
        currencyCode: 'CAD',
        value: 'CA',
        dial_code: '+1',
        timezone: 'GMT-08:00'
    },
    {
        label: 'Cabo Verde',
        currencyCode: 'CVE',
        value: 'CV',
        dial_code: '+238',
        timezone: 'GMT-01:00'
    },
    {
        label: 'Cayman Islands',
        currencyCode: 'KYD',
        value: 'KY',
        dial_code: '+1345',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Central African Republic',
        currencyCode: 'XAF',
        value: 'CF',
        dial_code: '+236',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Chad',
        currencyCode: 'XAF',
        value: 'TD',
        dial_code: '+235',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Chile',
        currencyCode: 'CLP',
        value: 'CL',
        dial_code: '+56',
        timezone: 'GMT-06:00'
    },
    {
        label: 'China',
        currencyCode: 'CNY',
        value: 'CN',
        dial_code: '+86',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Christmas Island',
        currencyCode: 'AUD',
        value: 'CX',
        dial_code: '+61',
        timezone: 'UTC+07:00'
    },
    {
        label: 'Cocos (Keeling) Islands',
        currencyCode: 'AUD',
        value: 'CC',
        dial_code: '+61',
        timezone: 'UTC+06:30'
    },
    {
        label: 'Colombia',
        currencyCode: 'COP',
        value: 'CO',
        dial_code: '+57',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Comoros',
        currencyCode: 'KMF',
        value: 'KM',
        dial_code: '+269',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Congo',
        currencyCode: 'XAF',
        value: 'CG',
        dial_code: '+242',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Congo (Democratic Republic of the)',
        currencyCode: 'CDF',
        value: 'CD',
        dial_code: '+243',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Cook Islands',
        currencyCode: 'NZD',
        value: 'CK',
        dial_code: '+682',
        timezone: 'GMT-10:00'
    },
    {
        label: 'Costa Rica',
        currencyCode: 'CRC',
        value: 'CR',
        dial_code: '+506',
        timezone: 'GMT-06:00'
    },
    {
        label: 'Croatia',
        currencyCode: 'HRK',
        value: 'HR',
        dial_code: '+385',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Cuba',
        currencyCode: 'CUC',
        value: 'CU',
        dial_code: '+53',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Curaçao',
        currencyCode: 'ANG',
        value: 'CW',
        dial_code: '+599',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Cyprus',
        currencyCode: 'EUR',
        value: 'CY',
        dial_code: '+357',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Czech Republic',
        currencyCode: 'CZK',
        value: 'CZ',
        dial_code: '+420',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Denmark',
        currencyCode: 'DKK',
        value: 'DK',
        dial_code: '+45',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Djibouti',
        currencyCode: 'DJF',
        value: 'DJ',
        dial_code: '+253',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Dominica',
        currencyCode: 'XCD',
        value: 'DM',
        dial_code: '+1767',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Dominican Republic',
        currencyCode: 'DOP',
        value: 'DO',
        dial_code: '+1809',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Ecuador',
        currencyCode: 'USD',
        value: 'EC',
        dial_code: '+593',
        timezone: 'GMT-06:00'
    },
    {
        label: 'Egypt',
        currencyCode: 'EGP',
        value: 'EG',
        dial_code: '+20',
        timezone: 'UTC+02:00'
    },
    {
        label: 'El Salvador',
        currencyCode: 'USD',
        value: 'SV',
        dial_code: '+503',
        timezone: 'GMT-06:00'
    },
    {
        label: 'Equatorial Guinea',
        currencyCode: 'XAF',
        value: 'GQ',
        dial_code: '+240',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Eritrea',
        currencyCode: 'ERN',
        value: 'ER',
        dial_code: '+291',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Estonia',
        currencyCode: 'EUR',
        value: 'EE',
        dial_code: '+372',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Ethiopia',
        currencyCode: 'ETB',
        value: 'ET',
        dial_code: '+251',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Falkland Islands (Malvinas)',
        currencyCode: 'FKP',
        value: 'FK',
        dial_code: '+500',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Faroe Islands',
        currencyCode: 'DKK',
        value: 'FO',
        dial_code: '+298',
        timezone: 'UTC+00:00'
    },
    {
        label: 'Fiji',
        currencyCode: 'FJD',
        value: 'FJ',
        dial_code: '+679',
        timezone: 'UTC+12:00'
    },
    {
        label: 'Finland',
        currencyCode: 'EUR',
        value: 'FI',
        dial_code: '+358',
        timezone: 'UTC+02:00'
    },
    {
        label: 'France',
        currencyCode: 'EUR',
        value: 'FR',
        dial_code: '+33',
        timezone: 'GMT-10:00'
    },
    {
        label: 'French Guiana',
        currencyCode: 'EUR',
        value: 'GF',
        dial_code: '+594',
        timezone: 'GMT-03:00'
    },
    {
        label: 'French Polynesia',
        currencyCode: 'XPF',
        value: 'PF',
        dial_code: '+689',
        timezone: 'GMT-10:00'
    },
    {
        label: 'French Southern Territories',
        currencyCode: 'EUR',
        value: 'TF',
        dial_code: '+',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Gabon',
        currencyCode: 'XAF',
        value: 'GA',
        dial_code: '+241',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Gambia',
        currencyCode: 'GMD',
        value: 'GM',
        dial_code: '+220',
        timezone: 'UTC+00:00'
    },
    {
        label: 'Georgia',
        currencyCode: 'GEL',
        value: 'GE',
        dial_code: '+995',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Germany',
        currencyCode: 'EUR',
        value: 'DE',
        dial_code: '+49',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Ghana',
        currencyCode: 'GHS',
        value: 'GH',
        dial_code: '+233',
        timezone: 'GMT'
    },
    {
        label: 'Gibraltar',
        currencyCode: 'GIP',
        value: 'GI',
        dial_code: '+350',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Greece',
        currencyCode: 'EUR',
        value: 'GR',
        dial_code: '+30',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Greenland',
        currencyCode: 'DKK',
        value: 'GL',
        dial_code: '+299',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Grenada',
        currencyCode: 'XCD',
        value: 'GD',
        dial_code: '+1473',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Guadeloupe',
        currencyCode: 'EUR',
        value: 'GP',
        dial_code: '+590',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Guam',
        currencyCode: 'USD',
        value: 'GU',
        dial_code: '+1671',
        timezone: 'UTC+10:00'
    },
    {
        label: 'Guatemala',
        currencyCode: 'GTQ',
        value: 'GT',
        dial_code: '+502',
        timezone: 'GMT-06:00'
    },
    {
        label: 'Guernsey',
        currencyCode: 'GBP',
        value: 'GG',
        dial_code: '+44',
        timezone: 'UTC+00:00'
    },
    {
        label: 'Guinea',
        currencyCode: 'GNF',
        value: 'GN',
        dial_code: '+224',
        timezone: 'GMT'
    },
    {
        label: 'Guinea-Bissau',
        currencyCode: 'XOF',
        value: 'GW',
        dial_code: '+245',
        timezone: 'GMT'
    },
    {
        label: 'Guyana',
        currencyCode: 'GYD',
        value: 'GY',
        dial_code: '+592',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Haiti',
        currencyCode: 'HTG',
        value: 'HT',
        dial_code: '+509',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Heard Island and McDonald Islands',
        currencyCode: 'AUD',
        value: 'HM',
        dial_code: '+',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Holy See',
        currencyCode: 'EUR',
        value: 'VA',
        dial_code: '+379',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Honduras',
        currencyCode: 'HNL',
        value: 'HN',
        dial_code: '+504',
        timezone: 'GMT-06:00'
    },
    {
        label: 'Hong Kong',
        currencyCode: 'HKD',
        value: 'HK',
        dial_code: '+852',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Hungary',
        currencyCode: 'HUF',
        value: 'HU',
        dial_code: '+36',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Iceland',
        currencyCode: 'ISK',
        value: 'IS',
        dial_code: '+354',
        timezone: 'GMT'
    },
    {
        label: 'India',
        currencyCode: 'INR',
        value: 'IN',
        dial_code: '+91',
        timezone: 'UTC+05:30'
    },
    {
        label: 'Indonesia',
        currencyCode: 'IDR',
        value: 'ID',
        dial_code: '+62',
        timezone: 'UTC+07:00'
    },
    {
        label: "Côte d'Ivoire",
        currencyCode: 'XOF',
        value: 'CI',
        dial_code: '+225',
        timezone: 'GMT'
    },
    {
        label: 'Iran (Islamic Republic of)',
        currencyCode: 'IRR',
        value: 'IR',
        dial_code: '+98',
        timezone: 'UTC+03:30'
    },
    {
        label: 'Iraq',
        currencyCode: 'IQD',
        value: 'IQ',
        dial_code: '+964',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Ireland',
        currencyCode: 'EUR',
        value: 'IE',
        dial_code: '+353',
        timezone: 'GMT'
    },
    {
        label: 'Isle of Man',
        currencyCode: 'GBP',
        value: 'IM',
        dial_code: '+44',
        timezone: 'UTC+00:00'
    },
    {
        label: 'Israel',
        currencyCode: 'ILS',
        value: 'IL',
        dial_code: '+972',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Italy',
        currencyCode: 'EUR',
        value: 'IT',
        dial_code: '+39',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Jamaica',
        currencyCode: 'JMD',
        value: 'JM',
        dial_code: '+1876',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Japan',
        currencyCode: 'JPY',
        value: 'JP',
        dial_code: '+81',
        timezone: 'UTC+09:00'
    },
    {
        label: 'Jersey',
        currencyCode: 'GBP',
        value: 'JE',
        dial_code: '+44',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Jordan',
        currencyCode: 'JOD',
        value: 'JO',
        dial_code: '+962',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Kazakhstan',
        currencyCode: 'KZT',
        value: 'KZ',
        dial_code: '+76',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Kenya',
        currencyCode: 'KES',
        value: 'KE',
        dial_code: '+254',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Kiribati',
        currencyCode: 'AUD',
        value: 'KI',
        dial_code: '+686',
        timezone: 'UTC+12:00'
    },
    {
        label: 'Kuwait',
        currencyCode: 'KWD',
        value: 'KW',
        dial_code: '+965',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Kyrgyzstan',
        currencyCode: 'KGS',
        value: 'KG',
        dial_code: '+996',
        timezone: 'UTC+06:00'
    },
    {
        label: "Lao People's Democratic Republic",
        currencyCode: 'LAK',
        value: 'LA',
        dial_code: '+856',
        timezone: 'UTC+07:00'
    },
    {
        label: 'Latvia',
        currencyCode: 'EUR',
        value: 'LV',
        dial_code: '+371',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Lebanon',
        currencyCode: 'LBP',
        value: 'LB',
        dial_code: '+961',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Lesotho',
        currencyCode: 'LSL',
        value: 'LS',
        dial_code: '+266',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Liberia',
        currencyCode: 'LRD',
        value: 'LR',
        dial_code: '+231',
        timezone: 'GMT'
    },
    {
        label: 'Libya',
        currencyCode: 'LYD',
        value: 'LY',
        dial_code: '+218',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Liechtenstein',
        currencyCode: 'CHF',
        value: 'LI',
        dial_code: '+423',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Lithuania',
        currencyCode: 'EUR',
        value: 'LT',
        dial_code: '+370',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Luxembourg',
        currencyCode: 'EUR',
        value: 'LU',
        dial_code: '+352',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Macao',
        currencyCode: 'MOP',
        value: 'MO',
        dial_code: '+853',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Macedonia (the former Yugoslav Republic of)',
        currencyCode: 'MKD',
        value: 'MK',
        dial_code: '+389',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Madagascar',
        currencyCode: 'MGA',
        value: 'MG',
        dial_code: '+261',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Malawi',
        currencyCode: 'MWK',
        value: 'MW',
        dial_code: '+265',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Malaysia',
        currencyCode: 'MYR',
        value: 'MY',
        dial_code: '+60',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Maldives',
        currencyCode: 'MVR',
        value: 'MV',
        dial_code: '+960',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Mali',
        currencyCode: 'XOF',
        value: 'ML',
        dial_code: '+223',
        timezone: 'GMT'
    },
    {
        label: 'Malta',
        currencyCode: 'EUR',
        value: 'MT',
        dial_code: '+356',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Marshall Islands',
        currencyCode: 'USD',
        value: 'MH',
        dial_code: '+692',
        timezone: 'UTC+12:00'
    },
    {
        label: 'Martinique',
        currencyCode: 'EUR',
        value: 'MQ',
        dial_code: '+596',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Mauritania',
        currencyCode: 'MRO',
        value: 'MR',
        dial_code: '+222',
        timezone: 'GMT'
    },
    {
        label: 'Mauritius',
        currencyCode: 'MUR',
        value: 'MU',
        dial_code: '+230',
        timezone: 'UTC+04:00'
    },
    {
        label: 'Mayotte',
        currencyCode: 'EUR',
        value: 'YT',
        dial_code: '+262',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Mexico',
        currencyCode: 'MXN',
        value: 'MX',
        dial_code: '+52',
        timezone: 'GMT-08:00'
    },
    {
        label: 'Micronesia (Federated States of)',
        currencyCode: null,
        value: 'FM',
        dial_code: '+691',
        timezone: 'UTC+10:00'
    },
    {
        label: 'Moldova (Republic of)',
        currencyCode: 'MDL',
        value: 'MD',
        dial_code: '+373',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Monaco',
        currencyCode: 'EUR',
        value: 'MC',
        dial_code: '+377',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Mongolia',
        currencyCode: 'MNT',
        value: 'MN',
        dial_code: '+976',
        timezone: 'UTC+07:00'
    },
    {
        label: 'Montenegro',
        currencyCode: 'EUR',
        value: 'ME',
        dial_code: '+382',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Montserrat',
        currencyCode: 'XCD',
        value: 'MS',
        dial_code: '+1664',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Morocco',
        currencyCode: 'MAD',
        value: 'MA',
        dial_code: '+212',
        timezone: 'GMT'
    },
    {
        label: 'Mozambique',
        currencyCode: 'MZN',
        value: 'MZ',
        dial_code: '+258',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Myanmar',
        currencyCode: 'MMK',
        value: 'MM',
        dial_code: '+95',
        timezone: 'UTC+06:30'
    },
    {
        label: 'Namibia',
        currencyCode: 'NAD',
        value: 'NA',
        dial_code: '+264',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Nauru',
        currencyCode: 'AUD',
        value: 'NR',
        dial_code: '+674',
        timezone: 'UTC+12:00'
    },
    {
        label: 'Nepal',
        currencyCode: 'NPR',
        value: 'NP',
        dial_code: '+977',
        timezone: 'UTC+05:45'
    },
    {
        label: 'Netherlands',
        currencyCode: 'EUR',
        value: 'NL',
        dial_code: '+31',
        timezone: 'GMT-04:00'
    },
    {
        label: 'New Caledonia',
        currencyCode: 'XPF',
        value: 'NC',
        dial_code: '+687',
        timezone: 'UTC+11:00'
    },
    {
        label: 'New Zealand',
        currencyCode: 'NZD',
        value: 'NZ',
        dial_code: '+64',
        timezone: 'GMT-11:00'
    },
    {
        label: 'Nicaragua',
        currencyCode: 'NIO',
        value: 'NI',
        dial_code: '+505',
        timezone: 'GMT-06:00'
    },
    {
        label: 'Niger',
        currencyCode: 'XOF',
        value: 'NE',
        dial_code: '+227',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Nigeria',
        currencyCode: 'NGN',
        value: 'NG',
        dial_code: '+234',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Niue',
        currencyCode: 'NZD',
        value: 'NU',
        dial_code: '+683',
        timezone: 'GMT-11:00'
    },
    {
        label: 'Norfolk Island',
        currencyCode: 'AUD',
        value: 'NF',
        dial_code: '+672',
        timezone: 'UTC+11:30'
    },
    {
        label: "Korea (Democratic People's Republic of)",
        currencyCode: 'KPW',
        value: 'KP',
        dial_code: '+850',
        timezone: 'UTC+09:00'
    },
    {
        label: 'Northern Mariana Islands',
        currencyCode: 'USD',
        value: 'MP',
        dial_code: '+1670',
        timezone: 'UTC+10:00'
    },
    {
        label: 'Norway',
        currencyCode: 'NOK',
        value: 'NO',
        dial_code: '+47',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Oman',
        currencyCode: 'OMR',
        value: 'OM',
        dial_code: '+968',
        timezone: 'UTC+04:00'
    },
    {
        label: 'Pakistan',
        currencyCode: 'PKR',
        value: 'PK',
        dial_code: '+92',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Palau',
        currencyCode: '(none)',
        value: 'PW',
        dial_code: '+680',
        timezone: 'UTC+09:00'
    },
    {
        label: 'Palestine, State of',
        currencyCode: 'ILS',
        value: 'PS',
        dial_code: '+970',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Panama',
        currencyCode: 'PAB',
        value: 'PA',
        dial_code: '+507',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Papua New Guinea',
        currencyCode: 'PGK',
        value: 'PG',
        dial_code: '+675',
        timezone: 'UTC+10:00'
    },
    {
        label: 'Paraguay',
        currencyCode: 'PYG',
        value: 'PY',
        dial_code: '+595',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Peru',
        currencyCode: 'PEN',
        value: 'PE',
        dial_code: '+51',
        timezone: 'GMT-05:00'
    },
    {
        label: 'Philippines',
        currencyCode: 'PHP',
        value: 'PH',
        dial_code: '+63',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Pitcairn',
        currencyCode: 'NZD',
        value: 'PN',
        dial_code: '+64',
        timezone: 'GMT-08:00'
    },
    {
        label: 'Poland',
        currencyCode: 'PLN',
        value: 'PL',
        dial_code: '+48',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Portugal',
        currencyCode: 'EUR',
        value: 'PT',
        dial_code: '+351',
        timezone: 'GMT-01:00'
    },
    {
        label: 'Puerto Rico',
        currencyCode: 'USD',
        value: 'PR',
        dial_code: '+1787',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Qatar',
        currencyCode: 'QAR',
        value: 'QA',
        dial_code: '+974',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Republic of Kosovo',
        currencyCode: 'EUR',
        value: 'XK',
        dial_code: '+383',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Réunion',
        currencyCode: 'EUR',
        value: 'RE',
        dial_code: '+262',
        timezone: 'UTC+04:00'
    },
    {
        label: 'Romania',
        currencyCode: 'RON',
        value: 'RO',
        dial_code: '+40',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Russian Federation',
        currencyCode: 'RUB',
        value: 'RU',
        dial_code: '+7',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Rwanda',
        currencyCode: 'RWF',
        value: 'RW',
        dial_code: '+250',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Saint Barthélemy',
        currencyCode: 'EUR',
        value: 'BL',
        dial_code: '+590',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Saint Helena, Ascension and Tristan da Cunha',
        currencyCode: 'SHP',
        value: 'SH',
        dial_code: '+290',
        timezone: 'UTC+00:00'
    },
    {
        label: 'Saint Kitts and Nevis',
        currencyCode: 'XCD',
        value: 'KN',
        dial_code: '+1869',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Saint Lucia',
        currencyCode: 'XCD',
        value: 'LC',
        dial_code: '+1758',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Saint Martin (French part)',
        currencyCode: 'EUR',
        value: 'MF',
        dial_code: '+590',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Saint Pierre and Miquelon',
        currencyCode: 'EUR',
        value: 'PM',
        dial_code: '+508',
        timezone: 'GMT-03:00'
    },
    {
        label: 'Saint Vincent and the Grenadines',
        currencyCode: 'XCD',
        value: 'VC',
        dial_code: '+1784',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Samoa',
        currencyCode: 'WST',
        value: 'WS',
        dial_code: '+685',
        timezone: 'UTC+13:00'
    },
    {
        label: 'San Marino',
        currencyCode: 'EUR',
        value: 'SM',
        dial_code: '+378',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Sao Tome and Principe',
        currencyCode: 'STD',
        value: 'ST',
        dial_code: '+239',
        timezone: 'GMT'
    },
    {
        label: 'Saudi Arabia',
        currencyCode: 'SAR',
        value: 'SA',
        dial_code: '+966',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Senegal',
        currencyCode: 'XOF',
        value: 'SN',
        dial_code: '+221',
        timezone: 'GMT'
    },
    {
        label: 'Serbia',
        currencyCode: 'RSD',
        value: 'RS',
        dial_code: '+381',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Seychelles',
        currencyCode: 'SCR',
        value: 'SC',
        dial_code: '+248',
        timezone: 'UTC+04:00'
    },
    {
        label: 'Sierra Leone',
        currencyCode: 'SLL',
        value: 'SL',
        dial_code: '+232',
        timezone: 'GMT'
    },
    {
        label: 'Singapore',
        currencyCode: 'SGD',
        value: 'SG',
        dial_code: '+65',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Sint Maarten (DGMTh part)',
        currencyCode: 'ANG',
        value: 'SX',
        dial_code: '+1721',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Slovakia',
        currencyCode: 'EUR',
        value: 'SK',
        dial_code: '+421',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Slovenia',
        currencyCode: 'EUR',
        value: 'SI',
        dial_code: '+386',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Solomon Islands',
        currencyCode: 'SBD',
        value: 'SB',
        dial_code: '+677',
        timezone: 'UTC+11:00'
    },
    {
        label: 'Somalia',
        currencyCode: 'SOS',
        value: 'SO',
        dial_code: '+252',
        timezone: 'UTC+03:00'
    },
    {
        label: 'South Africa',
        currencyCode: 'ZAR',
        value: 'ZA',
        dial_code: '+27',
        timezone: 'UTC+02:00'
    },
    {
        label: 'South Georgia and the South Sandwich Islands',
        currencyCode: 'GBP',
        value: 'GS',
        dial_code: '+500',
        timezone: 'GMT-02:00'
    },
    {
        label: 'Korea (Republic of)',
        currencyCode: 'KRW',
        value: 'KR',
        dial_code: '+82',
        timezone: 'UTC+09:00'
    },
    {
        label: 'South Sudan',
        currencyCode: 'SSP',
        value: 'SS',
        dial_code: '+211',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Spain',
        currencyCode: 'EUR',
        value: 'ES',
        dial_code: '+34',
        timezone: 'GMT'
    },
    {
        label: 'Sri Lanka',
        currencyCode: 'LKR',
        value: 'LK',
        dial_code: '+94',
        timezone: 'UTC+05:30'
    },
    {
        label: 'Sudan',
        currencyCode: 'SDG',
        value: 'SD',
        dial_code: '+249',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Suriname',
        currencyCode: 'SRD',
        value: 'SR',
        dial_code: '+597',
        timezone: 'GMT-03:00'
    },
    {
        label: 'Svalbard and Jan Mayen',
        currencyCode: 'NOK',
        value: 'SJ',
        dial_code: '+4779',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Swaziland',
        currencyCode: 'SZL',
        value: 'SZ',
        dial_code: '+268',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Sweden',
        currencyCode: 'SEK',
        value: 'SE',
        dial_code: '+46',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Switzerland',
        currencyCode: 'CHF',
        value: 'CH',
        dial_code: '+41',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Syrian Arab Republic',
        currencyCode: 'SYP',
        value: 'SY',
        dial_code: '+963',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Taiwan',
        currencyCode: 'TWD',
        value: 'TW',
        dial_code: '+886',
        timezone: 'UTC+08:00'
    },
    {
        label: 'Tajikistan',
        currencyCode: 'TJS',
        value: 'TJ',
        dial_code: '+992',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Tanzania, United Republic of',
        currencyCode: 'TZS',
        value: 'TZ',
        dial_code: '+255',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Thailand',
        currencyCode: 'THB',
        value: 'TH',
        dial_code: '+66',
        timezone: 'UTC+07:00'
    },
    {
        label: 'Timor-Leste',
        currencyCode: 'USD',
        value: 'TL',
        dial_code: '+670',
        timezone: 'UTC+09:00'
    },
    {
        label: 'Togo',
        currencyCode: 'XOF',
        value: 'TG',
        dial_code: '+228',
        timezone: 'GMT'
    },
    {
        label: 'Tokelau',
        currencyCode: 'NZD',
        value: 'TK',
        dial_code: '+690',
        timezone: 'UTC+13:00'
    },
    {
        label: 'Tonga',
        currencyCode: 'TOP',
        value: 'TO',
        dial_code: '+676',
        timezone: 'UTC+13:00'
    },
    {
        label: 'Trinidad and Tobago',
        currencyCode: 'TTD',
        value: 'TT',
        dial_code: '+1868',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Tunisia',
        currencyCode: 'TND',
        value: 'TN',
        dial_code: '+216',
        timezone: 'UTC+01:00'
    },
    {
        label: 'Turkey',
        currencyCode: 'TRY',
        value: 'TR',
        dial_code: '+90',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Turkmenistan',
        currencyCode: 'TMT',
        value: 'TM',
        dial_code: '+993',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Turks and Caicos Islands',
        currencyCode: 'USD',
        value: 'TC',
        dial_code: '+1649',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Tuvalu',
        currencyCode: 'AUD',
        value: 'TV',
        dial_code: '+688',
        timezone: 'UTC+12:00'
    },
    {
        label: 'Uganda',
        currencyCode: 'UGX',
        value: 'UG',
        dial_code: '+256',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Ukraine',
        currencyCode: 'UAH',
        value: 'UA',
        dial_code: '+380',
        timezone: 'UTC+02:00'
    },
    {
        label: 'United Arab Emirates',
        currencyCode: 'AED',
        value: 'AE',
        dial_code: '+971',
        timezone: 'UTC+04'
    },
    {
        label: 'United Kingdom',
        currencyCode: 'GBP',
        value: 'UK',
        dial_code: '+44',
        timezone: 'GMT-08:00'
    },
    {
        label: 'United Kingdom of Great Britain and Northern Ireland',
        currencyCode: 'GBP',
        value: 'GB',
        dial_code: '+44',
        timezone: 'GMT-08:00'
    },
    {
        label: 'United States of America',
        currencyCode: 'USD',
        value: 'US',
        dial_code: '+1',
        timezone: 'GMT-12:00'
    },
    {
        label: 'Uruguay',
        currencyCode: 'UYU',
        value: 'UY',
        dial_code: '+598',
        timezone: 'GMT-03:00'
    },
    {
        label: 'Uzbekistan',
        currencyCode: 'UZS',
        value: 'UZ',
        dial_code: '+998',
        timezone: 'UTC+05:00'
    },
    {
        label: 'Vanuatu',
        currencyCode: 'VUV',
        value: 'VU',
        dial_code: '+678',
        timezone: 'UTC+11:00'
    },
    {
        label: 'Venezuela (Bolivarian Republic of)',
        currencyCode: 'VEF',
        value: 'VE',
        dial_code: '+58',
        timezone: 'GMT-04:00'
    },
    {
        label: 'Viet Nam',
        currencyCode: 'VND',
        value: 'VN',
        dial_code: '+84',
        timezone: 'UTC+07:00'
    },
    {
        label: 'Wallis and Futuna',
        currencyCode: 'XPF',
        value: 'WF',
        dial_code: '+681',
        timezone: 'UTC+12:00'
    },
    {
        label: 'Western Sahara',
        currencyCode: 'MAD',
        value: 'EH',
        dial_code: '+212',
        timezone: 'UTC+00:00'
    },
    {
        label: 'Yemen',
        currencyCode: 'YER',
        value: 'YE',
        dial_code: '+967',
        timezone: 'UTC+03:00'
    },
    {
        label: 'Zambia',
        currencyCode: 'ZMW',
        value: 'ZM',
        dial_code: '+260',
        timezone: 'UTC+02:00'
    },
    {
        label: 'Zimbabwe',
        currencyCode: 'BWP',
        value: 'ZW',
        dial_code: '+263',
        timezone: 'UTC+02:00'
    }
];

export const COMPLIANCE_COUNTRIES = ["IN", "US", "MY", "SG"];

export const IN_STATES = [
    {
        value: 'AN',
        label: 'Andaman and Nicobar Islands'
    },
    {
        value: 'AP',
        label: 'Andhra Pradesh'
    },
    {
        value: 'AR',
        label: 'Arunachal Pradesh'
    },
    {
        value: 'AS',
        label: 'Assam'
    },
    {
        value: 'BR',
        label: 'Bihar'
    },
    {
        value: 'CG',
        label: 'Chandigarh'
    },
    {
        value: 'CH',
        label: 'Chhattisgarh'
    },
    {
        value: 'DH',
        label: 'Dadra and Nagar Haveli'
    },
    {
        value: 'DD',
        label: 'Daman and Diu'
    },
    {
        value: 'DL',
        label: 'Delhi'
    },
    {
        value: 'GA',
        label: 'Goa'
    },
    {
        value: 'GJ',
        label: 'Gujarat'
    },
    {
        value: 'HR',
        label: 'Haryana'
    },
    {
        value: 'HP',
        label: 'Himachal Pradesh'
    },
    {
        value: 'JK',
        label: 'Jammu and Kashmir'
    },
    {
        value: 'JH',
        label: 'Jharkhand'
    },
    {
        value: 'KA',
        label: 'Karnataka'
    },
    {
        value: 'KL',
        label: 'Kerala'
    },
    {
        value: "LA",
        label: "Ladakh"
    },
    {
        value: 'LD',
        label: 'Lakshadweep'
    },
    {
        value: 'MP',
        label: 'Madhya Pradesh'
    },
    {
        value: 'MH',
        label: 'Maharashtra'
    },
    {
        value: 'MN',
        label: 'Manipur'
    },
    {
        value: 'ML',
        label: 'Meghalaya'
    },
    {
        value: 'MZ',
        label: 'Mizoram'
    },
    {
        value: 'NL',
        label: 'Nagaland'
    },
    {
        value: 'OR',
        label: 'Odisha'
    },
    {
        value: 'PY',
        label: 'Puducherry'
    },
    {
        value: 'PB',
        label: 'Punjab'
    },
    {
        value: 'RJ',
        label: 'Rajasthan'
    },
    {
        value: 'SK',
        label: 'Sikkim'
    },
    {
        value: 'TN',
        label: 'Tamil Nadu'
    },
    {
        value: 'TS',
        label: 'Telangana'
    },
    {
        value: 'TR',
        label: 'Tripura'
    },
    {
        value: 'UP',
        label: 'Uttar Pradesh'
    },
    {
        value: 'UK',
        label: 'Uttarakhand'
    },
    {
        value: 'WB',
        label: 'West Bengal'
    }
];

export const US_STATES = [
    {
        value: 'AL',
        label: 'Alabama'
    },
    {
        value: 'AK',
        label: 'Alaska'
    },
    {
        value: 'AS',
        label: 'American Samoa'
    },
    {
        value: 'AZ',
        label: 'Arizona'
    },
    {
        value: 'AR',
        label: 'Arkansas'
    },
    {
        value: 'CA',
        label: 'California'
    },
    {
        value: 'CO',
        label: 'Colorado'
    },
    {
        value: 'CT',
        label: 'Connecticut'
    },
    {
        value: 'DE',
        label: 'Delaware'
    },
    {
        value: 'DC',
        label: 'District of Columbia'
    },
    {
        value: 'FL',
        label: 'Florida'
    },
    {
        value: 'GA',
        label: 'Georgia'
    },
    {
        value: 'GU',
        label: 'Guam'
    },
    {
        value: 'HI',
        label: 'Hawaii'
    },
    {
        value: 'ID',
        label: 'Idaho'
    },
    {
        value: 'IL',
        label: 'Illinois'
    },
    {
        value: 'IN',
        label: 'Indiana'
    },
    {
        value: 'IA',
        label: 'Iowa'
    },
    {
        value: 'KS',
        label: 'Kansas'
    },
    {
        value: 'KY',
        label: 'Kentucky'
    },
    {
        value: 'LA',
        label: 'Louisiana'
    },
    {
        value: 'ME',
        label: 'Maine'
    },
    {
        value: 'MD',
        label: 'Maryland'
    },
    {
        value: 'MA',
        label: 'Massachusetts'
    },
    {
        value: 'MI',
        label: 'Michigan'
    },
    {
        value: 'MN',
        label: 'Minnesota'
    },
    {
        value: 'MS',
        label: 'Mississippi'
    },
    {
        value: 'MO',
        label: 'Missouri'
    },
    {
        value: 'MT',
        label: 'Montana'
    },
    {
        value: 'NE',
        label: 'Nebraska'
    },
    {
        value: 'NV',
        label: 'Nevada'
    },
    {
        value: 'NH',
        label: 'New Hampshire'
    },
    {
        value: 'NJ',
        label: 'New Jersey'
    },
    {
        value: 'NM',
        label: 'New Mexico'
    },
    {
        value: 'NY',
        label: 'New York'
    },
    {
        value: 'NC',
        label: 'North Carolina'
    },
    {
        value: 'ND',
        label: 'North Dakota'
    },
    {
        value: 'MP',
        label: 'Northern Mariana Islands'
    },
    {
        value: 'OH',
        label: 'Ohio'
    },
    {
        value: 'OK',
        label: 'Oklahoma'
    },
    {
        value: 'OR',
        label: 'Oregon'
    },
    {
        value: 'PA',
        label: 'Pennsylvania'
    },
    {
        value: 'PR',
        label: 'Puerto Rico'
    },
    {
        value: 'RI',
        label: 'Rhode Island'
    },
    {
        value: 'SC',
        label: 'South Carolina'
    },
    {
        value: 'SD',
        label: 'South Dakota'
    },
    {
        value: 'TN',
        label: 'Tennessee'
    },
    {
        value: 'TX',
        label: 'Texas'
    },
    {
        value: 'UM',
        label: 'United States Minor Outlying Islands'
    },
    {
        value: 'UT',
        label: 'Utah'
    },
    {
        value: 'VT',
        label: 'Vermont'
    },
    {
        value: 'VI',
        label: 'Virgin Islands, U.S.'
    },
    {
        value: 'VA',
        label: 'Virginia'
    },
    {
        value: 'WA',
        label: 'Washington'
    },
    {
        value: 'WV',
        label: 'West Virginia'
    },
    {
        value: 'WI',
        label: 'Wisconsin'
    },
    {
        value: 'WY',
        label: 'Wyoming'
    }
];

export const US_COUNTIES = {
    Alabama: [
        'Autauga',
        'Baldwin',
        'Barbour',
        'Bibb',
        'Blount',
        'Bullock',
        'Butler',
        'Calhoun',
        'Chambers',
        'Cherokee',
        'Chilton',
        'Choctaw',
        'Clarke',
        'Clay',
        'Cleburne',
        'Coffee',
        'Colbert',
        'Conecuh',
        'Coosa',
        'Covington',
        'Crenshaw',
        'Cullman',
        'Dale',
        'Dallas',
        'DeKalb',
        'Elmore',
        'Escambia',
        'Etowah',
        'Fayette',
        'Franklin',
        'Geneva',
        'Greene',
        'Hale',
        'Henry',
        'Houston',
        'Jackson',
        'Jefferson',
        'Lamar',
        'Lauderdale',
        'Lawrence',
        'Lee',
        'Limestone',
        'Lowndes',
        'Macon',
        'Madison',
        'Marengo',
        'Marion',
        'Marshall',
        'Mobile',
        'Monroe',
        'Montgomery',
        'Morgan',
        'Perry',
        'Pickens',
        'Pike',
        'Randolph',
        'Russell',
        'St. Clair',
        'Shelby',
        'Sumter',
        'Talladega',
        'Tallapoosa',
        'Tuscaloosa',
        'Walker',
        'Washington',
        'Wilcox',
        'Winston'
    ],
    Alaska: [
        'Aleutians East Borough',
        'Municipality of Anchorage',
        'Bristol Bay Borough',
        'Denali Borough',
        'Fairbanks North Star Borough',
        'Borough of Haines',
        'City and Borough of Juneau',
        'Kenai Peninsula Borough',
        'Ketchikan Gateway Borough',
        'Kodiak Island Borough',
        'Lake and Peninsula Borough',
        'Matanuska-Susitna Borough',
        'North Slope Borough',
        'Northwest Arctic Borough',
        'Petersburg Borough',
        'City and Borough of Sitka',
        'Municipality of Skagway Borough',
        'City and Borough of Wrangell',
        'City and Borough of Yakutat',
        'Unorganized Borough',
        'Aleutians West Census Area',
        'Bethel Census Area',
        'Dillingham Census Area',
        'Hoonah-Angoon Census Area',
        'Kusilvak Census Area',
        'Nome Census Area',
        'Prince of Wales-Hyder Census Area',
        'Southeast Fairbanks Census Area',
        'Valdez-Cordova Census Area',
        'Yukon-Koyukuk Census Area'
    ],
    Arizona: [
        'Apache',
        'Cochise',
        'Coconino',
        'Gila',
        'Graham',
        'Greenlee',
        'La Paz',
        'Maricopa',
        'Mohave',
        'Navajo',
        'Pima',
        'Pinal',
        'Santa Cruz',
        'Yavapai',
        'Yuma'
    ],
    Arkansas: [
        'Arkansas',
        'Ashley',
        'Baxter',
        'Benton',
        'Boone',
        'Bradley',
        'Calhoun',
        'Carroll',
        'Chicot',
        'Clark',
        'Clay',
        'Cleburne',
        'Cleveland',
        'Columbia',
        'Conway',
        'Craighead',
        'Crawford',
        'Crittenden',
        'Cross',
        'Dallas',
        'Desha',
        'Drew',
        'Faulkner',
        'Franklin',
        'Fulton',
        'Garland',
        'Grant',
        'Greene',
        'Hempstead',
        'Hot Spring',
        'Howard',
        'Independence',
        'Izard',
        'Jackson',
        'Jefferson',
        'Johnson',
        'Lafayette',
        'Lawrence',
        'Lee',
        'Lincoln',
        'Little River',
        'Logan',
        'Lonoke',
        'Madison',
        'Marion',
        'Miller',
        'Mississippi',
        'Monroe',
        'Montgomery',
        'Nevada',
        'Newton',
        'Ouachita',
        'Perry',
        'Phillips',
        'Pike',
        'Poinsett',
        'Polk',
        'Pope',
        'Prairie',
        'Pulaski',
        'Randolph',
        'St. Francis',
        'Saline',
        'Scott',
        'Searcy',
        'Sebastian',
        'Sevier',
        'Sharp',
        'Stone',
        'Union',
        'Van Buren',
        'Washington',
        'White',
        'Woodruff',
        'Yell'
    ],
    California: [
        'Alameda',
        'Alpine',
        'Amador',
        'Butte',
        'Calaveras',
        'Colusa',
        'Contra Costa',
        'Del Norte',
        'El Dorado',
        'Fresno',
        'Glenn',
        'Humboldt',
        'Imperial',
        'Inyo',
        'Kern',
        'Kings',
        'Lake',
        'Lassen',
        'Los Angeles',
        'Madera',
        'Marin',
        'Mariposa',
        'Mendocino',
        'Merced',
        'Modoc',
        'Mono',
        'Monterey',
        'Napa',
        'Nevada',
        'Orange',
        'Placer',
        'Plumas',
        'Riverside',
        'Sacramento',
        'San Benito',
        'San Bernardino',
        'San Diego',
        'City and County of San Francisco, California',
        'San Joaquin',
        'San Luis Obispo',
        'San Mateo',
        'Santa Barbara',
        'Santa Clara',
        'Santa Cruz',
        'Shasta',
        'Sierra',
        'Siskiyou',
        'Solano',
        'Sonoma',
        'Stanislaus',
        'Sutter',
        'Tehama',
        'Trinity',
        'Tulare',
        'Tuolumne',
        'Ventura',
        'Yolo',
        'Yuba'
    ],
    Colorado: [
        'Adams',
        'Alamosa',
        'Arapahoe',
        'Archuleta',
        'Baca',
        'Bent',
        'Boulder',
        'City and County of Broomfield',
        'Chaffee',
        'Cheyenne',
        'Clear Creek',
        'Conejos',
        'Costilla',
        'Crowley',
        'Custer',
        'Delta',
        'City and County of Denver',
        'Dolores',
        'Douglas',
        'Eagle',
        'Elbert',
        'El Paso',
        'Fremont',
        'Garfield',
        'Gilpin',
        'Grand',
        'Gunnison',
        'Hinsdale',
        'Huerfano',
        'Jackson',
        'Jefferson',
        'Kiowa',
        'Kit Carson',
        'Lake',
        'La Plata',
        'Larimer',
        'Las Animas',
        'Lincoln',
        'Logan',
        'Mesa',
        'Mineral',
        'Moffat',
        'Montezuma',
        'Montrose',
        'Morgan',
        'Otero',
        'Ouray',
        'Park',
        'Phillips',
        'Pitkin',
        'Prowers',
        'Pueblo',
        'Rio Blanco',
        'Rio Grande',
        'Routt',
        'Saguache',
        'San Juan',
        'San Miguel',
        'Sedgwick',
        'Summit',
        'Teller',
        'Washington',
        'Weld',
        'Yuma'
    ],
    Connecticut: [
        'Fairfield',
        'Hartford',
        'Litchfield',
        'Middlesex',
        'New Haven',
        'New London',
        'Tolland',
        'Windham'
    ],
    Delaware: [
        'Kent',
        'New Castle',
        'Sussex'
    ],
    'District Of Columbia': [
        'District of Columbia'
    ],
    Florida: [
        'Alachua',
        'Baker',
        'Bay',
        'Bradford',
        'Brevard',
        'Broward',
        'Calhoun',
        'Charlotte',
        'Citrus',
        'Clay',
        'Collier',
        'Columbia',
        'DeSoto',
        'Dixie',
        'Duval',
        'Escambia',
        'Flagler',
        'Franklin',
        'Gadsden',
        'Gilchrist',
        'Glades',
        'Gulf',
        'Hamilton',
        'Hardee',
        'Hendry',
        'Hernando',
        'Highlands',
        'Hillsborough',
        'Holmes',
        'Indian River',
        'Jackson',
        'Jefferson',
        'Lafayette',
        'Lake',
        'Lee',
        'Leon',
        'Levy',
        'Liberty',
        'Madison',
        'Manatee',
        'Marion',
        'Martin',
        'Miami-Dade',
        'Monroe',
        'Nassau',
        'Okaloosa',
        'Okeechobee',
        'Orange',
        'Osceola',
        'Palm Beach',
        'Pasco',
        'Pinellas',
        'Polk',
        'Putnam',
        'St. Johns',
        'St. Lucie',
        'Santa Rosa',
        'Sarasota',
        'Seminole',
        'Sumter',
        'Suwannee',
        'Taylor',
        'Union',
        'Volusia',
        'Wakulla',
        'Walton',
        'Washington'
    ],
    Georgia: [
        'Appling',
        'Atkinson',
        'Bacon',
        'Baker',
        'Baldwin',
        'Banks',
        'Barrow',
        'Bartow',
        'Ben Hill',
        'Berrien',
        'Bibb',
        'Bleckley',
        'Brantley',
        'Brooks',
        'Bryan',
        'Bulloch',
        'Burke',
        'Butts',
        'Calhoun',
        'Camden',
        'Candler',
        'Carroll',
        'Catoosa',
        'Charlton',
        'Chatham',
        'Chattahoochee',
        'Chattooga',
        'Cherokee',
        'Clarke',
        'Clay',
        'Clayton',
        'Clinch',
        'Cobb',
        'Coffee',
        'Colquitt',
        'Columbia',
        'Cook',
        'Coweta',
        'Crawford',
        'Crisp',
        'Dade',
        'Dawson',
        'Decatur',
        'DeKalb',
        'Dodge',
        'Dooly',
        'Dougherty',
        'Douglas',
        'Early',
        'Echols',
        'Effingham',
        'Elbert',
        'Emanuel',
        'Evans',
        'Fannin',
        'Fayette',
        'Floyd',
        'Forsyth',
        'Franklin',
        'Fulton',
        'Gilmer',
        'Glascock',
        'Glynn',
        'Gordon',
        'Grady',
        'Greene',
        'Gwinnett',
        'Habersham',
        'Hall',
        'Hancock',
        'Haralson',
        'Harris',
        'Hart',
        'Heard',
        'Henry',
        'Houston',
        'Irwin',
        'Jackson',
        'Jasper',
        'Jeff Davis',
        'Jefferson',
        'Jenkins',
        'Johnson',
        'Jones',
        'Lamar',
        'Lanier',
        'Laurens',
        'Lee',
        'Liberty',
        'Lincoln',
        'Long',
        'Lowndes',
        'Lumpkin',
        'McDuffie',
        'McIntosh',
        'Macon',
        'Madison',
        'Marion',
        'Meriwether',
        'Miller',
        'Mitchell',
        'Monroe',
        'Montgomery',
        'Morgan',
        'Murray',
        'Muscogee',
        'Newton',
        'Oconee',
        'Oglethorpe',
        'Paulding',
        'Peach',
        'Pickens',
        'Pierce',
        'Pike',
        'Polk',
        'Pulaski',
        'Putnam',
        'Quitman',
        'Rabun',
        'Randolph',
        'Richmond',
        'Rockdale',
        'Schley',
        'Screven',
        'Seminole',
        'Spalding',
        'Stephens',
        'Stewart',
        'Sumter',
        'Talbot',
        'Taliaferro',
        'Tattnall',
        'Taylor',
        'Telfair',
        'Terrell',
        'Thomas',
        'Tift',
        'Toombs',
        'Towns',
        'Treutlen',
        'Troup',
        'Turner',
        'Twiggs',
        'Union',
        'Upson',
        'Walker',
        'Walton',
        'Ware',
        'Warren',
        'Washington',
        'Wayne',
        'Webster',
        'Wheeler',
        'White',
        'Whitfield',
        'Wilcox',
        'Wilkes',
        'Wilkinson',
        'Worth'
    ],
    Guam: [
        'Guam'
    ],
    Hawaii: [
        'Hawaii',
        'City and County of Honolulu',
        'Kalawao',
        'Kauai',
        'Maui'
    ],
    Idaho: [
        'Ada',
        'Adams',
        'Bannock',
        'Bear Lake',
        'Benewah',
        'Bingham',
        'Blaine',
        'Boise',
        'Bonner',
        'Bonneville',
        'Boundary',
        'Butte',
        'Camas',
        'Canyon',
        'Caribou',
        'Cassia',
        'Clark',
        'Clearwater',
        'Custer',
        'Elmore',
        'Franklin',
        'Fremont',
        'Gem',
        'Gooding',
        'Idaho',
        'Jefferson',
        'Jerome',
        'Kootenai',
        'Latah',
        'Lemhi',
        'Lewis',
        'Lincoln',
        'Madison',
        'Minidoka',
        'Nez Perce',
        'Oneida',
        'Owyhee',
        'Payette',
        'Power',
        'Shoshone',
        'Teton',
        'Twin Falls',
        'Valley',
        'Washington'
    ],
    Illinois: [
        'Adams',
        'Alexander',
        'Bond',
        'Boone',
        'Brown',
        'Bureau',
        'Calhoun',
        'Carroll',
        'Cass',
        'Champaign',
        'Christian',
        'Clark',
        'Clay',
        'Clinton',
        'Coles',
        'Cook',
        'Crawford',
        'Cumberland',
        'DeKalb',
        'De Witt',
        'Douglas',
        'DuPage',
        'Edgar',
        'Edwards',
        'Effingham',
        'Fayette',
        'Ford',
        'Franklin',
        'Fulton',
        'Gallatin',
        'Greene',
        'Grundy',
        'Hamilton',
        'Hancock',
        'Hardin',
        'Henderson',
        'Henry',
        'Iroquois',
        'Jackson',
        'Jasper',
        'Jefferson',
        'Jersey',
        'Jo Daviess',
        'Johnson',
        'Kane',
        'Kankakee',
        'Kendall',
        'Knox',
        'Lake',
        'LaSalle',
        'Lawrence',
        'Lee',
        'Livingston',
        'Logan',
        'McDonough',
        'McHenry',
        'McLean',
        'Macon',
        'Macoupin',
        'Madison',
        'Marion',
        'Marshall',
        'Mason',
        'Massac',
        'Menard',
        'Mercer',
        'Monroe',
        'Montgomery',
        'Morgan',
        'Moultrie',
        'Ogle',
        'Peoria',
        'Perry',
        'Piatt',
        'Pike',
        'Pope',
        'Pulaski',
        'Putnam',
        'Randolph',
        'Richland',
        'Rock Island',
        'St. Clair',
        'Saline',
        'Sangamon',
        'Schuyler',
        'Scott',
        'Shelby',
        'Stark',
        'Stephenson',
        'Tazewell',
        'Union',
        'Vermilion',
        'Wabash',
        'Warren',
        'Washington',
        'Wayne',
        'White',
        'Whiteside',
        'Will',
        'Williamson',
        'Winnebago',
        'Woodford'
    ],
    Indiana: [
        'Adams',
        'Allen',
        'Bartholomew',
        'Benton',
        'Blackford',
        'Boone',
        'Brown',
        'Carroll',
        'Cass',
        'Clark',
        'Clay',
        'Clinton',
        'Crawford',
        'Daviess',
        'Dearborn',
        'Decatur',
        'DeKalb',
        'Delaware',
        'Dubois',
        'Elkhart',
        'Fayette',
        'Floyd',
        'Fountain',
        'Franklin',
        'Fulton',
        'Gibson',
        'Grant',
        'Greene',
        'Hamilton',
        'Hancock',
        'Harrison',
        'Hendricks',
        'Henry',
        'Howard',
        'Huntington',
        'Jackson',
        'Jasper',
        'Jay',
        'Jefferson',
        'Jennings',
        'Johnson',
        'Knox',
        'Kosciusko',
        'LaGrange',
        'Lake',
        'LaPorte',
        'Lawrence',
        'Madison',
        'Marion',
        'Marshall',
        'Martin',
        'Miami',
        'Monroe',
        'Montgomery',
        'Morgan',
        'Newton',
        'Noble',
        'Ohio',
        'Orange',
        'Owen',
        'Parke',
        'Perry',
        'Pike',
        'Porter',
        'Posey',
        'Pulaski',
        'Putnam',
        'Randolph',
        'Ripley',
        'Rush',
        'St. Joseph',
        'Scott',
        'Shelby',
        'Spencer',
        'Starke',
        'Steuben',
        'Sullivan',
        'Switzerland',
        'Tippecanoe',
        'Tipton',
        'Union',
        'Vanderburgh',
        'Vermillion',
        'Vigo',
        'Wabash',
        'Warren',
        'Warrick',
        'Washington',
        'Wayne',
        'Wells',
        'White',
        'Whitley'
    ],
    Iowa: [
        'Adair',
        'Adams',
        'Allamakee',
        'Appanoose',
        'Audubon',
        'Benton',
        'Black Hawk',
        'Boone',
        'Bremer',
        'Buchanan',
        'Buena Vista',
        'Butler',
        'Calhoun',
        'Carroll',
        'Cass',
        'Cedar',
        'Cerro Gordo',
        'Cherokee',
        'Chickasaw',
        'Clarke',
        'Clay',
        'Clayton',
        'Clinton',
        'Crawford',
        'Dallas',
        'Davis',
        'Decatur',
        'Delaware',
        'Des Moines',
        'Dickinson',
        'Dubuque',
        'Emmet',
        'Fayette',
        'Floyd',
        'Franklin',
        'Fremont',
        'Greene',
        'Grundy',
        'Guthrie',
        'Hamilton',
        'Hancock',
        'Hardin',
        'Harrison',
        'Henry',
        'Howard',
        'Humboldt',
        'Ida',
        'Iowa',
        'Jackson',
        'Jasper',
        'Jefferson',
        'Johnson',
        'Jones',
        'Keokuk',
        'Kossuth',
        'Lee',
        'Linn',
        'Louisa',
        'Lucas',
        'Lyon',
        'Madison',
        'Mahaska',
        'Marion',
        'Marshall',
        'Mills',
        'Mitchell',
        'Monona',
        'Monroe',
        'Montgomery',
        'Muscatine',
        "O'Brien",
        'Osceola',
        'Page',
        'Palo Alto',
        'Plymouth',
        'Pocahontas',
        'Polk',
        'Pottawattamie',
        'Poweshiek',
        'Ringgold',
        'Sac',
        'Scott',
        'Shelby',
        'Sioux',
        'Story',
        'Tama',
        'Taylor',
        'Union',
        'Van Buren',
        'Wapello',
        'Warren',
        'Washington',
        'Wayne',
        'Webster',
        'Winnebago',
        'Winneshiek',
        'Woodbury',
        'Worth',
        'Wright'
    ],
    Kansas: [
        'Allen',
        'Anderson',
        'Atchison',
        'Barber',
        'Barton',
        'Bourbon',
        'Brown',
        'Butler',
        'Chase',
        'Chautauqua',
        'Cherokee',
        'Cheyenne',
        'Clark',
        'Clay',
        'Cloud',
        'Coffey',
        'Comanche',
        'Cowley',
        'Crawford',
        'Decatur',
        'Dickinson',
        'Doniphan',
        'Douglas',
        'Edwards',
        'Elk',
        'Ellis',
        'Ellsworth',
        'Finney',
        'Ford',
        'Franklin',
        'Geary',
        'Gove',
        'Graham',
        'Grant',
        'Gray',
        'Greeley',
        'Greenwood',
        'Hamilton',
        'Harper',
        'Harvey',
        'Haskell',
        'Hodgeman',
        'Jackson',
        'Jefferson',
        'Jewell',
        'Johnson',
        'Kearny',
        'Kingman',
        'Kiowa',
        'Labette',
        'Lane',
        'Leavenworth',
        'Lincoln',
        'Linn',
        'Logan',
        'Lyon',
        'McPherson',
        'Marion',
        'Marshall',
        'Meade',
        'Miami',
        'Mitchell',
        'Montgomery',
        'Morris',
        'Morton',
        'Nemaha',
        'Neosho',
        'Ness',
        'Norton',
        'Osage',
        'Osborne',
        'Ottawa',
        'Pawnee',
        'Phillips',
        'Pottawatomie',
        'Pratt',
        'Rawlins',
        'Reno',
        'Republic',
        'Rice',
        'Riley',
        'Rooks',
        'Rush',
        'Russell',
        'Saline',
        'Scott',
        'Sedgwick',
        'Seward',
        'Shawnee',
        'Sheridan',
        'Sherman',
        'Smith',
        'Stafford',
        'Stanton',
        'Stevens',
        'Sumner',
        'Thomas',
        'Trego',
        'Wabaunsee',
        'Wallace',
        'Washington',
        'Wichita',
        'Wilson',
        'Woodson',
        'Wyandotte'
    ],
    Kentucky: [
        'Adair',
        'Allen',
        'Anderson',
        'Ballard',
        'Barren',
        'Bath',
        'Bell',
        'Boone',
        'Bourbon',
        'Boyd',
        'Boyle',
        'Bracken',
        'Breathitt',
        'Breckinridge',
        'Bullitt',
        'Butler',
        'Caldwell',
        'Calloway',
        'Campbell',
        'Carlisle',
        'Carroll',
        'Carter',
        'Casey',
        'Christian',
        'Clark',
        'Clay',
        'Clinton',
        'Crittenden',
        'Cumberland',
        'Daviess',
        'Edmonson',
        'Elliott',
        'Estill',
        'Fayette',
        'Fleming',
        'Floyd',
        'Franklin',
        'Fulton',
        'Gallatin',
        'Garrard',
        'Grant',
        'Graves',
        'Grayson',
        'Green',
        'Greenup',
        'Hancock',
        'Hardin',
        'Harlan',
        'Harrison',
        'Hart',
        'Henderson',
        'Henry',
        'Hickman',
        'Hopkins',
        'Jackson',
        'Jefferson',
        'Jessamine',
        'Johnson',
        'Kenton',
        'Knott',
        'Knox',
        'LaRue',
        'Laurel',
        'Lawrence',
        'Lee',
        'Leslie',
        'Letcher',
        'Lewis',
        'Lincoln',
        'Livingston',
        'Logan',
        'Lyon',
        'McCracken',
        'McCreary',
        'McLean',
        'Madison',
        'Magoffin',
        'Marion',
        'Marshall',
        'Martin',
        'Mason',
        'Meade',
        'Menifee',
        'Mercer',
        'Metcalfe',
        'Monroe',
        'Montgomery',
        'Morgan',
        'Muhlenberg',
        'Nelson',
        'Nicholas',
        'Ohio',
        'Oldham',
        'Owen',
        'Owsley',
        'Pendleton',
        'Perry',
        'Pike',
        'Powell',
        'Pulaski',
        'Robertson',
        'Rockcastle',
        'Rowan',
        'Russell',
        'Scott',
        'Shelby',
        'Simpson',
        'Spencer',
        'Taylor',
        'Todd',
        'Trigg',
        'Trimble',
        'Union',
        'Warren',
        'Washington',
        'Wayne',
        'Webster',
        'Whitley',
        'Wolfe',
        'Woodford'
    ],
    Louisiana: [
        'Acadia',
        'Allen',
        'Ascension',
        'Assumption',
        'Avoyelles',
        'Beauregard',
        'Bienville',
        'Bossier',
        'Caddo',
        'Calcasieu',
        'Caldwell',
        'Cameron',
        'Catahoula',
        'Claiborne',
        'Concordia',
        'De Soto',
        'East Baton Rouge',
        'East Carroll',
        'East Feliciana',
        'Evangeline',
        'Franklin',
        'Grant',
        'Iberia',
        'Iberville',
        'Jackson',
        'Jefferson',
        'Jefferson Davis',
        'Lafayette',
        'Lafourche',
        'La Salle',
        'Lincoln',
        'Livingston',
        'Madison',
        'Morehouse',
        'Natchitoches',
        'Orleans',
        'Ouachita',
        'Plaquemines',
        'Pointe Coupee',
        'Rapides',
        'Red River',
        'Richland',
        'Sabine',
        'St. Bernard',
        'St. Charles',
        'St. Helena',
        'St. James',
        'St. John the Baptist',
        'St. Landry',
        'St. Martin',
        'St. Mary',
        'St. Tammany',
        'Tangipahoa',
        'Tensas',
        'Terrebonne',
        'Union',
        'Vermilion',
        'Vernon',
        'Washington',
        'Webster',
        'West Baton Rouge',
        'West Carroll',
        'West Feliciana',
        'Winn'
    ],
    Maine: [
        'Androscoggin',
        'Aroostook',
        'Cumberland',
        'Franklin',
        'Hancock',
        'Kennebec',
        'Knox',
        'Lincoln',
        'Oxford',
        'Penobscot',
        'Piscataquis',
        'Sagadahoc',
        'Somerset',
        'Waldo',
        'Washington',
        'York'
    ],
    Maryland: [
        'Allegany',
        'Anne Arundel',
        'Baltimore',
        'Calvert',
        'Caroline',
        'Carroll',
        'Cecil',
        'Charles',
        'Dorchester',
        'Frederick',
        'Garrett',
        'Harford',
        'Howard',
        'Kent',
        'Montgomery',
        "Prince George's",
        "Queen Anne's",
        "St. Mary's",
        'Somerset',
        'Talbot',
        'Washington',
        'Wicomico',
        'Worcester',
        'City of Baltimore'
    ],
    Massachusetts: [
        'Barnstable',
        'Berkshire',
        'Bristol',
        'Dukes',
        'Essex',
        'Franklin',
        'Hampden',
        'Hampshire',
        'Middlesex',
        'Town and County of Nantucket',
        'Norfolk',
        'Plymouth',
        'Suffolk',
        'Worcester'
    ],
    Michigan: [
        'Alcona',
        'Alger',
        'Allegan',
        'Alpena',
        'Antrim',
        'Arenac',
        'Baraga',
        'Barry',
        'Bay',
        'Benzie',
        'Berrien',
        'Branch',
        'Calhoun',
        'Cass',
        'Charlevoix',
        'Cheboygan',
        'Chippewa',
        'Clare',
        'Clinton',
        'Crawford',
        'Delta',
        'Dickinson',
        'Eaton',
        'Emmet',
        'Genesee',
        'Gladwin',
        'Gogebic',
        'Grand Traverse',
        'Gratiot',
        'Hillsdale',
        'Houghton',
        'Huron',
        'Ingham',
        'Ionia',
        'Iosco',
        'Iron',
        'Isabella',
        'Jackson',
        'Kalamazoo',
        'Kalkaska',
        'Kent',
        'Keweenaw',
        'Lake',
        'Lapeer',
        'Leelanau',
        'Lenawee',
        'Livingston',
        'Luce',
        'Mackinac',
        'Macomb',
        'Manistee',
        'Marquette',
        'Mason',
        'Mecosta',
        'Menominee',
        'Midland',
        'Missaukee',
        'Monroe',
        'Montcalm',
        'Montmorency',
        'Muskegon',
        'Newaygo',
        'Oakland',
        'Oceana',
        'Ogemaw',
        'Ontonagon',
        'Osceola',
        'Oscoda',
        'Otsego',
        'Ottawa',
        'Presque Isle',
        'Roscommon',
        'Saginaw',
        'St. Clair',
        'St. Joseph',
        'Sanilac',
        'Schoolcraft',
        'Shiawassee',
        'Tuscola',
        'Van Buren',
        'Washtenaw',
        'Wayne',
        'Wexford'
    ],
    Minnesota: [
        'Aitkin',
        'Anoka',
        'Becker',
        'Beltrami',
        'Benton',
        'Big Stone',
        'Blue Earth',
        'Brown',
        'Carlton',
        'Carver',
        'Cass',
        'Chippewa',
        'Chisago',
        'Clay',
        'Clearwater',
        'Cook',
        'Cottonwood',
        'Crow Wing',
        'Dakota',
        'Dodge',
        'Douglas',
        'Faribault',
        'Fillmore',
        'Freeborn',
        'Goodhue',
        'Grant',
        'Hennepin',
        'Houston',
        'Hubbard',
        'Isanti',
        'Itasca',
        'Jackson',
        'Kanabec',
        'Kandiyohi',
        'Kittson',
        'Koochiching',
        'Lac qui Parle',
        'Lake',
        'Lake of the Woods',
        'Le Sueur',
        'Lincoln',
        'Lyon',
        'McLeod',
        'Mahnomen',
        'Marshall',
        'Martin',
        'Meeker',
        'Mille Lacs',
        'Morrison',
        'Mower',
        'Murray',
        'Nicollet',
        'Nobles',
        'Norman',
        'Olmsted',
        'Otter Tail',
        'Pennington',
        'Pine',
        'Pipestone',
        'Polk',
        'Pope',
        'Ramsey',
        'Red Lake',
        'Redwood',
        'Renville',
        'Rice',
        'Rock',
        'Roseau',
        'St. Louis',
        'Scott',
        'Sherburne',
        'Sibley',
        'Stearns',
        'Steele',
        'Stevens',
        'Swift',
        'Todd',
        'Traverse',
        'Wabasha',
        'Wadena',
        'Waseca',
        'Washington',
        'Watonwan',
        'Wilkin',
        'Winona',
        'Wright',
        'Yellow Medicine'
    ],
    Mississippi: [
        'Adams',
        'Alcorn',
        'Amite',
        'Attala',
        'Benton',
        'Bolivar',
        'Calhoun',
        'Carroll',
        'Chickasaw',
        'Choctaw',
        'Claiborne',
        'Clarke',
        'Clay',
        'Coahoma',
        'Copiah',
        'Covington',
        'DeSoto',
        'Forrest',
        'Franklin',
        'George',
        'Greene',
        'Grenada',
        'Hancock',
        'Harrison',
        'Hinds',
        'Holmes',
        'Humphreys',
        'Issaquena',
        'Itawamba',
        'Jackson',
        'Jasper',
        'Jefferson',
        'Jefferson Davis',
        'Jones',
        'Kemper',
        'Lafayette',
        'Lamar',
        'Lauderdale',
        'Lawrence',
        'Leake',
        'Lee',
        'Leflore',
        'Lincoln',
        'Lowndes',
        'Madison',
        'Marion',
        'Marshall',
        'Monroe',
        'Montgomery',
        'Neshoba',
        'Newton',
        'Noxubee',
        'Oktibbeha',
        'Panola',
        'Pearl River',
        'Perry',
        'Pike',
        'Pontotoc',
        'Prentiss',
        'Quitman',
        'Rankin',
        'Scott',
        'Sharkey',
        'Simpson',
        'Smith',
        'Stone',
        'Sunflower',
        'Tallahatchie',
        'Tate',
        'Tippah',
        'Tishomingo',
        'Tunica',
        'Union',
        'Walthall',
        'Warren',
        'Washington',
        'Wayne',
        'Webster',
        'Wilkinson',
        'Winston',
        'Yalobusha',
        'Yazoo'
    ],
    Missouri: [
        'Adair',
        'Andrew',
        'Atchison',
        'Audrain',
        'Barry',
        'Barton',
        'Bates',
        'Benton',
        'Bollinger',
        'Boone',
        'Buchanan',
        'Butler',
        'Caldwell',
        'Callaway',
        'Camden',
        'Cape Girardeau',
        'Carroll',
        'Carter',
        'Cass',
        'Cedar',
        'Chariton',
        'Christian',
        'Clark',
        'Clay',
        'Clinton',
        'Cole',
        'Cooper',
        'Crawford',
        'Dade',
        'Dallas',
        'Daviess',
        'DeKalb',
        'Dent',
        'Douglas',
        'Dunklin',
        'Franklin',
        'Gasconade',
        'Gentry',
        'Greene',
        'Grundy',
        'Harrison',
        'Henry',
        'Hickory',
        'Holt',
        'Howard',
        'Howell',
        'Iron',
        'Jackson',
        'Jasper',
        'Jefferson',
        'Johnson',
        'Knox',
        'Laclede',
        'Lafayette',
        'Lawrence',
        'Lewis',
        'Lincoln',
        'Linn',
        'Livingston',
        'McDonald',
        'Macon',
        'Madison',
        'Maries',
        'Marion',
        'Mercer',
        'Miller',
        'Mississippi',
        'Moniteau',
        'Monroe',
        'Montgomery',
        'Morgan',
        'New Madrid',
        'Newton',
        'Nodaway',
        'Oregon',
        'Osage',
        'Ozark',
        'Pemiscot',
        'Perry',
        'Pettis',
        'Phelps',
        'Pike',
        'Platte',
        'Polk',
        'Pulaski',
        'Putnam',
        'Ralls',
        'Randolph',
        'Ray',
        'Reynolds',
        'Ripley',
        'St. Charles',
        'St. Clair',
        'Ste. Genevieve',
        'St. Francois',
        'City of St. Louis',
        'St. Louis',
        'Saline',
        'Schuyler',
        'Scotland',
        'Scott',
        'Shannon',
        'Shelby',
        'Stoddard',
        'Stone',
        'Sullivan',
        'Taney',
        'Texas',
        'Vernon',
        'Warren',
        'Washington',
        'Wayne',
        'Webster',
        'Worth',
        'Wright'
    ],
    Montana: [
        'Beaverhead',
        'Big Horn',
        'Blaine',
        'Broadwater',
        'Carbon',
        'Carter',
        'Cascade',
        'Chouteau',
        'Custer',
        'Daniels',
        'Dawson',
        'Deer Lodge',
        'Fallon',
        'Fergus',
        'Flathead',
        'Gallatin',
        'Garfield',
        'Glacier',
        'Golden Valley',
        'Granite',
        'Hill',
        'Jefferson',
        'Judith Basin',
        'Lake',
        'Lewis and Clark',
        'Liberty',
        'Lincoln',
        'McCone',
        'Madison',
        'Meagher',
        'Mineral',
        'Missoula',
        'Musselshell',
        'Park',
        'Petroleum',
        'Phillips',
        'Pondera',
        'Powder River',
        'Powell',
        'Prairie',
        'Ravalli',
        'Richland',
        'Roosevelt',
        'Rosebud',
        'Sanders',
        'Sheridan',
        'Silver Bow',
        'Stillwater',
        'Sweet Grass',
        'Teton',
        'Toole',
        'Treasure',
        'Valley',
        'Wheatland',
        'Wibaux',
        'Yellowstone'
    ],
    Nebraska: [
        'Adams',
        'Antelope',
        'Arthur',
        'Banner',
        'Blaine',
        'Boone',
        'Box Butte',
        'Boyd',
        'Brown',
        'Buffalo',
        'Burt',
        'Butler',
        'Cass',
        'Cedar',
        'Chase',
        'Cherry',
        'Cheyenne',
        'Clay',
        'Colfax',
        'Cuming',
        'Custer',
        'Dakota',
        'Dawes',
        'Dawson',
        'Deuel',
        'Dixon',
        'Dodge',
        'Douglas',
        'Dundy',
        'Fillmore',
        'Franklin',
        'Frontier',
        'Furnas',
        'Gage',
        'Garden',
        'Garfield',
        'Gosper',
        'Grant',
        'Greeley',
        'Hall',
        'Hamilton',
        'Harlan',
        'Hayes',
        'Hitchcock',
        'Holt',
        'Hooker',
        'Howard',
        'Jefferson',
        'Johnson',
        'Kearney',
        'Keith',
        'Keya Paha',
        'Kimball',
        'Knox',
        'Lancaster',
        'Lincoln',
        'Logan',
        'Loup',
        'McPherson',
        'Madison',
        'Merrick',
        'Morrill',
        'Nance',
        'Nemaha',
        'Nuckolls',
        'Otoe',
        'Pawnee',
        'Perkins',
        'Phelps',
        'Pierce',
        'Platte',
        'Polk',
        'Red Willow',
        'Richardson',
        'Rock',
        'Saline',
        'Sarpy',
        'Saunders',
        'Scotts Bluff',
        'Seward',
        'Sheridan',
        'Sherman',
        'Sioux',
        'Stanton',
        'Thayer',
        'Thomas',
        'Thurston',
        'Valley',
        'Washington',
        'Wayne',
        'Webster',
        'Wheeler',
        'York'
    ],
    Nevada: [
        'Consolidated Municipality of Carson City',
        'Churchill',
        'Clark',
        'Douglas',
        'Elko',
        'Esmeralda',
        'Eureka',
        'Humboldt',
        'Lander',
        'Lincoln',
        'Lyon',
        'Mineral',
        'Nye',
        'Pershing',
        'Storey',
        'Washoe',
        'White Pine'
    ],
    'New Hampshire': [
        'Belknap',
        'Carroll',
        'Cheshire',
        'Coös',
        'Grafton',
        'Hillsborough',
        'Merrimack',
        'Rockingham',
        'Strafford',
        'Sullivan'
    ],
    'New Jersey': [
        'Atlantic',
        'Bergen',
        'Burlington',
        'Camden',
        'Cape May',
        'Cumberland',
        'Essex',
        'Gloucester',
        'Hudson',
        'Hunterdon',
        'Mercer',
        'Middlesex',
        'Monmouth',
        'Morris',
        'Ocean',
        'Passaic',
        'Salem',
        'Somerset',
        'Sussex',
        'Union',
        'Warren'
    ],
    'New Mexico': [
        'Bernalillo',
        'Catron',
        'Chaves',
        'Cibola',
        'Colfax',
        'Curry',
        'De Baca',
        'Doña Ana',
        'Eddy',
        'Grant',
        'Guadalupe',
        'Harding',
        'Hidalgo',
        'Lea',
        'Lincoln',
        'Municipality and County of Los Alamo',
        'Luna',
        'McKinley',
        'Mora',
        'Otero',
        'Quay',
        'Rio Arriba',
        'Roosevelt',
        'Sandoval',
        'San Juan',
        'San Miguel',
        'Santa Fe',
        'Sierra',
        'Socorro',
        'Taos',
        'Torrance',
        'Union',
        'Valencia'
    ],
    'New York': [
        'Albany',
        'Allegany',
        'Bronx',
        'Broome',
        'Cattaraugus',
        'Cayuga',
        'Chautauqua',
        'Chemung',
        'Chenango',
        'Clinton',
        'Columbia',
        'Cortland',
        'Delaware',
        'Dutchess',
        'Erie',
        'Essex',
        'Franklin',
        'Fulton',
        'Genesee',
        'Greene',
        'Hamilton',
        'Herkimer',
        'Jefferson',
        'Kings',
        'Lewis',
        'Livingston',
        'Madison',
        'Monroe',
        'Montgomery',
        'Nassau',
        'New York',
        'Niagara',
        'Oneida',
        'Onondaga',
        'Ontario',
        'Orange',
        'Orleans',
        'Oswego',
        'Otsego',
        'Putnam',
        'Queens',
        'Rensselaer',
        'Richmond',
        'Rockland',
        'St. Lawrence',
        'Saratoga',
        'Schenectady',
        'Schoharie',
        'Schuyler',
        'Seneca',
        'Steuben',
        'Suffolk',
        'Sullivan',
        'Tioga',
        'Tompkins',
        'Ulster',
        'Warren',
        'Washington',
        'Wayne',
        'Westchester',
        'Wyoming',
        'Yates'
    ],
    'North Carolina': [
        'Alamance',
        'Alexander',
        'Alleghany',
        'Anson',
        'Ashe',
        'Avery',
        'Beaufort',
        'Bertie',
        'Bladen',
        'Brunswick',
        'Buncombe',
        'Burke',
        'Cabarrus',
        'Caldwell',
        'Camden',
        'Carteret',
        'Caswell',
        'Catawba',
        'Chatham',
        'Cherokee',
        'Chowan',
        'Clay',
        'Cleveland',
        'Columbus',
        'Craven',
        'Cumberland',
        'Currituck',
        'Dare',
        'Davidson',
        'Davie',
        'Duplin',
        'Durham',
        'Edgecombe',
        'Forsyth',
        'Franklin',
        'Gaston',
        'Gates',
        'Graham',
        'Granville',
        'Greene',
        'Guilford',
        'Halifax',
        'Harnett',
        'Haywood',
        'Henderson',
        'Hertford',
        'Hoke',
        'Hyde',
        'Iredell',
        'Jackson',
        'Johnston',
        'Jones',
        'Lee',
        'Lenoir',
        'Lincoln',
        'McDowell',
        'Macon',
        'Madison',
        'Martin',
        'Mecklenburg',
        'Mitchell',
        'Montgomery',
        'Moore',
        'Nash',
        'New Hanover',
        'Northampton',
        'Onslow',
        'Orange',
        'Pamlico',
        'Pasquotank',
        'Pender',
        'Perquimans',
        'Person',
        'Pitt',
        'Polk',
        'Randolph',
        'Richmond',
        'Robeson',
        'Rockingham',
        'Rowan',
        'Rutherford',
        'Sampson',
        'Scotland',
        'Stanly',
        'Stokes',
        'Surry',
        'Swain',
        'Transylvania',
        'Tyrrell',
        'Union',
        'Vance',
        'Wake',
        'Warren',
        'Washington',
        'Watauga',
        'Wayne',
        'Wilkes',
        'Wilson',
        'Yadkin',
        'Yancey'
    ],
    'North Dakota': [
        'Adams',
        'Barnes',
        'Benson',
        'Billings',
        'Bottineau',
        'Bowman',
        'Burke',
        'Burleigh',
        'Cass',
        'Cavalier',
        'Dickey',
        'Divide',
        'Dunn',
        'Eddy',
        'Emmons',
        'Foster',
        'Golden Valley',
        'Grand Forks',
        'Grant',
        'Griggs',
        'Hettinger',
        'Kidder',
        'LaMoure',
        'Logan',
        'McHenry',
        'McIntosh',
        'McKenzie',
        'McLean',
        'Mercer',
        'Morton',
        'Mountrail',
        'Nelson',
        'Oliver',
        'Pembina',
        'Pierce',
        'Ramsey',
        'Ransom',
        'Renville',
        'Richland',
        'Rolette',
        'Sargent',
        'Sheridan',
        'Sioux',
        'Slope',
        'Stark',
        'Steele',
        'Stutsman',
        'Towner',
        'Traill',
        'Walsh',
        'Ward',
        'Wells',
        'Williams'
    ],
    Ohio: [
        'Adams',
        'Allen',
        'Ashland',
        'Ashtabula',
        'Athens',
        'Auglaize',
        'Belmont',
        'Brown',
        'Butler',
        'Carroll',
        'Champaign',
        'Clark',
        'Clermont',
        'Clinton',
        'Columbiana',
        'Coshocton',
        'Crawford',
        'Cuyahoga',
        'Darke',
        'Defiance',
        'Delaware',
        'Erie',
        'Fairfield',
        'Fayette',
        'Franklin',
        'Fulton',
        'Gallia',
        'Geauga',
        'Greene',
        'Guernsey',
        'Hamilton',
        'Hancock',
        'Hardin',
        'Harrison',
        'Henry',
        'Highland',
        'Hocking',
        'Holmes',
        'Huron',
        'Jackson',
        'Jefferson',
        'Knox',
        'Lake',
        'Lawrence',
        'Licking',
        'Logan',
        'Lorain',
        'Lucas',
        'Madison',
        'Mahoning',
        'Marion',
        'Medina',
        'Meigs',
        'Mercer',
        'Miami',
        'Monroe',
        'Montgomery',
        'Morgan',
        'Morrow',
        'Muskingum',
        'Noble',
        'Ottawa',
        'Paulding',
        'Perry',
        'Pickaway',
        'Pike',
        'Portage',
        'Preble',
        'Putnam',
        'Richland',
        'Ross',
        'Sandusky',
        'Scioto',
        'Seneca',
        'Shelby',
        'Stark',
        'Summit',
        'Trumbull',
        'Tuscarawas',
        'Union',
        'Van Wert',
        'Vinton',
        'Warren',
        'Washington',
        'Wayne',
        'Williams',
        'Wood',
        'Wyandot'
    ],
    Oklahoma: [
        'Adair',
        'Alfalfa',
        'Atoka',
        'Beaver',
        'Beckham',
        'Blaine',
        'Bryan',
        'Caddo',
        'Canadian',
        'Carter',
        'Cherokee',
        'Choctaw',
        'Cimarron',
        'Cleveland',
        'Coal',
        'Comanche',
        'Cotton',
        'Craig',
        'Creek',
        'Custer',
        'Delaware',
        'Dewey',
        'Ellis',
        'Garfield',
        'Garvin',
        'Grady',
        'Grant',
        'Greer',
        'Harmon',
        'Harper',
        'Haskell',
        'Hughes',
        'Jackson',
        'Jefferson',
        'Johnston',
        'Kay',
        'Kingfisher',
        'Kiowa',
        'Latimer',
        'Le Flore',
        'Lincoln',
        'Logan',
        'Love',
        'McClain',
        'McCurtain',
        'McIntosh',
        'Major',
        'Marshall',
        'Mayes',
        'Murray',
        'Muskogee',
        'Noble',
        'Nowata',
        'Okfuskee',
        'Oklahoma',
        'Okmulgee',
        'Osage',
        'Ottawa',
        'Pawnee',
        'Payne',
        'Pittsburg',
        'Pontotoc',
        'Pottawatomie',
        'Pushmataha',
        'Roger Mills',
        'Rogers',
        'Seminole',
        'Sequoyah',
        'Stephens',
        'Texas',
        'Tillman',
        'Tulsa',
        'Wagoner',
        'Washington',
        'Washita',
        'Woods',
        'Woodward'
    ],
    Oregon: [
        'Baker',
        'Benton',
        'Clackamas',
        'Clatsop',
        'Columbia',
        'Coos',
        'Crook',
        'Curry',
        'Deschutes',
        'Douglas',
        'Gilliam',
        'Grant',
        'Harney',
        'Hood River',
        'Jackson',
        'Jefferson',
        'Josephine',
        'Klamath',
        'Lake',
        'Lane',
        'Lincoln',
        'Linn',
        'Malheur',
        'Marion',
        'Morrow',
        'Multnomah',
        'Polk',
        'Sherman',
        'Tillamook',
        'Umatilla',
        'Union',
        'Wallowa',
        'Wasco',
        'Washington',
        'Wheeler',
        'Yamhill'
    ],
    Pennsylvania: [
        'Adams',
        'Allegheny',
        'Armstrong',
        'Beaver',
        'Bedford',
        'Berks',
        'Blair',
        'Bradford',
        'Bucks',
        'Butler',
        'Cambria',
        'Cameron',
        'Carbon',
        'Centre',
        'Chester',
        'Clarion',
        'Clearfield',
        'Clinton',
        'Columbia',
        'Crawford',
        'Cumberland',
        'Dauphin',
        'Delaware',
        'Elk',
        'Erie',
        'Fayette',
        'Forest',
        'Franklin',
        'Fulton',
        'Greene',
        'Huntingdon',
        'Indiana',
        'Jefferson',
        'Juniata',
        'Lackawanna',
        'Lancaster',
        'Lawrence',
        'Lebanon',
        'Lehigh',
        'Luzerne',
        'Lycoming',
        'McKean',
        'Mercer',
        'Mifflin',
        'Monroe',
        'Montgomery',
        'Montour',
        'Northampton',
        'Northumberland',
        'Perry',
        'Philadelphia',
        'Pike',
        'Potter',
        'Schuylkill',
        'Snyder',
        'Somerset',
        'Sullivan',
        'Susquehanna',
        'Tioga',
        'Union',
        'Venango',
        'Warren',
        'Washington',
        'Wayne',
        'Westmoreland',
        'Wyoming',
        'York'
    ],
    'Rhode Island': [
        'Bristol',
        'Kent',
        'Newport',
        'Providence',
        'Washington'
    ],
    'South Carolina': [
        'Abbeville',
        'Aiken',
        'Allendale',
        'Anderson',
        'Bamberg',
        'Barnwell',
        'Beaufort',
        'Berkeley',
        'Calhoun',
        'Charleston',
        'Cherokee',
        'Chester',
        'Chesterfield',

        'Colleton',
        'Darlington',
        'Dillon',
        'Dorchester',
        'Edgefield',
        'Fairfield',
        'Florence',
        'Georgetown',
        'Greenville',
        'Greenwood',
        'Hampton',
        'Horry',
        'Jasper',
        'Kershaw',
        'Lancaster',
        'Laurens',
        'Lee',
        'Lexington',
        'McCormick',
        'Marion',
        'Marlboro',
        'Newberry',
        'Oconee',
        'Orangeburg',
        'Pickens',
        'Richland',
        'Saluda',
        'Spartanburg',
        'Sumter',
        'Union',
        'Williamsburg',
        'York'
    ],
    'South Dakota': [
        'Aurora',
        'Beadle',
        'Bennett',
        'Bon Homme',
        'Brookings',
        'Brown',
        'Brule',
        'Buffalo',
        'Butte',
        'Campbell',
        'Charles Mix',
        'Clark',
        'Clay',
        'Codington',
        'Corson',
        'Custer',
        'Davison',
        'Day',
        'Deuel',
        'Dewey',
        'Douglas',
        'Edmunds',
        'Fall River',
        'Faulk',
        'Grant',
        'Gregory',
        'Haakon',
        'Hamlin',
        'Hand',
        'Hanson',
        'Harding',
        'Hughes',
        'Hutchinson',
        'Hyde',
        'Jackson',
        'Jerauld',
        'Jones',
        'Kingsbury',
        'Lake',
        'Lawrence',
        'Lincoln',
        'Lyman',
        'McCook',
        'McPherson',
        'Marshall',
        'Meade',
        'Mellette',
        'Miner',
        'Minnehaha',
        'Moody',
        'Oglala Lakota',
        'Pennington',
        'Perkins',
        'Potter',
        'Roberts',
        'Sanborn',
        'Spink',
        'Stanley',
        'Sully',
        'Todd',
        'Tripp',
        'Turner',
        'Union',
        'Walworth',
        'Yankton',
        'Ziebach'
    ],
    Tennessee: [
        'Anderson',
        'Bedford',
        'Benton',
        'Bledsoe',
        'Blount',
        'Bradley',
        'Campbell',
        'Cannon',
        'Carroll',
        'Carter',
        'Cheatham',
        'Chester',
        'Claiborne',
        'Clay',
        'Cocke',
        'Coffee',
        'Crockett',
        'Cumberland',
        'Davidson',
        'Decatur',
        'DeKalb',
        'Dickson',
        'Dyer',
        'Fayette',
        'Fentress',
        'Franklin',
        'Gibson',
        'Giles',
        'Grainger',
        'Greene',
        'Grundy',
        'Hamblen',
        'Hamilton',
        'Hancock',
        'Hardeman',
        'Hardin',
        'Hawkins',
        'Haywood',
        'Henderson',
        'Henry',
        'Hickman',
        'Houston',
        'Humphreys',
        'Jackson',
        'Jefferson',
        'Johnson',
        'Knox',
        'Lake',
        'Lauderdale',
        'Lawrence',
        'Lewis',
        'Lincoln',
        'Loudon',
        'McMinn',
        'McNairy',
        'Macon',
        'Madison',
        'Marion',
        'Marshall',
        'Maury',
        'Meigs',
        'Monroe',
        'Montgomery',
        'Moore',
        'Morgan',
        'Obion',
        'Overton',
        'Perry',
        'Pickett',
        'Polk',
        'Putnam',
        'Rhea',
        'Roane',
        'Robertson',
        'Rutherford',
        'Scott',
        'Sequatchie',
        'Sevier',
        'Shelby',
        'Smith',
        'Stewart',
        'Sullivan',
        'Sumner',
        'Tipton',
        'Trousdale',
        'Unicoi',
        'Union',
        'Van Buren',
        'Warren',
        'Washington',
        'Wayne',
        'Weakley',
        'White',
        'Williamson',
        'Wilson'
    ],
    Texas: [
        'Anderson',
        'Andrews',
        'Angelina',
        'Aransas',
        'Archer',
        'Armstrong',
        'Atascosa',
        'Austin',
        'Bailey',
        'Bandera',
        'Bastrop',
        'Baylor',
        'Bee',
        'Bell',
        'Bexar',
        'Blanco',
        'Borden',
        'Bosque',
        'Bowie',
        'Brazoria',
        'Brazos',
        'Brewster',
        'Briscoe',
        'Brooks',
        'Brown',
        'Burleson',
        'Burnet',
        'Caldwell',
        'Calhoun',
        'Callahan',
        'Cameron',
        'Camp',
        'Carson',
        'Cass',
        'Castro',
        'Chambers',
        'Cherokee',
        'Childress',
        'Clay',
        'Cochran',
        'Coke',
        'Coleman',
        'Collin',
        'Collingsworth',
        'Colorado',
        'Comal',
        'Comanche',
        'Concho',
        'Cooke',
        'Coryell',
        'Cottle',
        'Crane',
        'Crockett',
        'Crosby',
        'Culberson',
        'Dallam',
        'Dallas',
        'Dawson',
        'Deaf Smith',
        'Delta',
        'Denton',
        'DeWitt',
        'Dickens',
        'Dimmit',
        'Donley',
        'Duval',
        'Eastland',
        'Ector',
        'Edwards',
        'Ellis',
        'El Paso',
        'Erath',
        'Falls',
        'Fannin',
        'Fayette',
        'Fisher',
        'Floyd',
        'Foard',
        'Fort Bend',
        'Franklin',
        'Freestone',
        'Frio',
        'Gaines',
        'Galveston',
        'Garza',
        'Gillespie',
        'Glasscock',
        'Goliad',
        'Gonzales',
        'Gray',
        'Grayson',
        'Gregg',
        'Grimes',
        'Guadalupe',
        'Hale',
        'Hall',
        'Hamilton',
        'Hansford',
        'Hardeman',
        'Hardin',
        'Harris',
        'Harrison',
        'Hartley',
        'Haskell',
        'Hays',
        'Hemphill',
        'Henderson',
        'Hidalgo',
        'Hill',
        'Hockley',
        'Hood',
        'Hopkins',
        'Houston',
        'Howard',
        'Hudspeth',
        'Hunt',
        'Hutchinson',
        'Irion',
        'Jack',
        'Jackson',
        'Jasper',
        'Jeff Davis',
        'Jefferson',
        'Jim Hogg',
        'Jim Wells',
        'Johnson',
        'Jones',
        'Karnes',
        'Kaufman',
        'Kendall',
        'Kenedy',
        'Kent',
        'Kerr',
        'Kimble',
        'King',
        'Kinney',
        'Kleberg',
        'Knox',
        'Lamar',
        'Lamb',
        'Lampasas',
        'La Salle',
        'Lavaca',
        'Lee',
        'Leon',
        'Liberty',
        'Limestone',
        'Lipscomb',
        'Live Oak',
        'Llano',
        'Loving',
        'Lubbock',
        'Lynn',
        'McCulloch',
        'McLennan',
        'McMullen',
        'Madison',
        'Marion',
        'Martin',
        'Mason',
        'Matagorda',
        'Maverick',
        'Medina',
        'Menard',
        'Midland',
        'Milam',
        'Mills',
        'Mitchell',
        'Montague',
        'Montgomery',
        'Moore',
        'Morris',
        'Motley',
        'Nacogdoches',
        'Navarro',
        'Newton',
        'Nolan',
        'Nueces',
        'Ochiltree',
        'Oldham',
        'Orange',
        'Palo Pinto',
        'Panola',
        'Parker',
        'Parmer',
        'Pecos',
        'Polk',
        'Potter',
        'Presidio',
        'Rains',
        'Randall',
        'Reagan',
        'Real',
        'Red River',
        'Reeves',
        'Refugio',
        'Roberts',
        'Robertson',
        'Rockwall',
        'Runnels',
        'Rusk',
        'Sabine',
        'San Augustine',
        'San Jacinto',
        'San Patricio',
        'San Saba',
        'Schleicher',
        'Scurry',
        'Shackelford',
        'Shelby',
        'Sherman',
        'Smith',
        'Somervell',
        'Starr',
        'Stephens',
        'Sterling',
        'Stonewall',
        'Sutton',
        'Swisher',
        'Tarrant',
        'Taylor',
        'Terrell',
        'Terry',
        'Throckmorton',
        'Titus',
        'Tom Green',
        'Travis',
        'Trinity',
        'Tyler',
        'Upshur',
        'Upton',
        'Uvalde',
        'Val Verde',
        'Van Zandt',
        'Victoria',
        'Walker',
        'Waller',
        'Ward',
        'Washington',
        'Webb',
        'Wharton',
        'Wheeler',
        'Wichita',
        'Wilbarger',
        'Willacy',
        'Williamson',
        'Wilson',
        'Winkler',
        'Wise',
        'Wood',
        'Yoakum',
        'Young',
        'Zapata',
        'Zavala'
    ],
    Utah: [
        'Beaver',
        'Box Elder',
        'Cache',
        'Carbon',
        'Daggett',
        'Davis',
        'Duchesne',
        'Emery',
        'Garfield',
        'Grand',
        'Iron',
        'Juab',
        'Kane',
        'Millard',
        'Morgan',
        'Piute',
        'Rich',
        'Salt Lake',
        'San Juan',
        'Sanpete',
        'Sevier',
        'Summit',
        'Tooele',
        'Uintah',
        'Utah',
        'Wasatch',
        'Washington',
        'Wayne',
        'Weber'
    ],
    Vermont: [
        'Addison',
        'Bennington',
        'Caledonia',
        'Chittenden',
        'Essex',
        'Franklin',
        'Grand Isle',
        'Lamoille',
        'Orange',
        'Orleans',
        'Rutland',
        'Washington',
        'Windham',

    ],
    Virginia: [
        'Accomack',
        'Albemarle',
        'Alleghany',
        'Amelia',
        'Amherst',
        'Appomattox',
        'Arlington',
        'Augusta',
        'Bath',
        'Bedford',
        'Bland',
        'Botetourt',
        'Brunswick',
        'Buchanan',
        'Buckingham',
        'Campbell',
        'Caroline',
        'Carroll',
        'Charles City',
        'Charlotte',
        'Chesterfield',
        'Clarke',
        'Craig',
        'Culpeper',
        'Cumberland',
        'Dickenson',
        'Dinwiddie',
        'Essex',
        'Fairfax',
        'Fauquier',
        'Floyd',
        'Fluvanna',
        'Franklin',
        'Frederick',
        'Giles',
        'Gloucester',
        'Goochland',
        'Grayson',
        'Greene',
        'Greensville',
        'Halifax',
        'Hanover',
        'Henrico',
        'Henry',
        'Highland',
        'Isle of Wight',
        'James City',
        'King and Queen',
        'King George',
        'King William',
        'Lancaster',
        'Lee',
        'Loudoun',
        'Louisa',
        'Lunenburg',
        'Madison',
        'Mathews',
        'Mecklenburg',
        'Middlesex',
        'Montgomery',
        'Nelson',
        'New Kent',
        'Northampton',
        'Northumberland',
        'Nottoway',
        'Orange',
        'Page',
        'Patrick',
        'Pittsylvania',
        'Powhatan',
        'Prince Edward',
        'Prince George',
        'Prince William',
        'Pulaski',
        'Rappahannock',
        'Richmond',
        'Roanoke',
        'Rockbridge',
        'Rockingham',
        'Russell',
        'Scott',
        'Shenandoah',
        'Smyth',
        'Southampton',
        'Spotsylvania',
        'Stafford',
        'Surry',
        'Sussex',
        'Tazewell',
        'Warren',
        'Washington',
        'Westmoreland',
        'Wise',
        'Wythe',
        'York',
        'City of Alexandria',
        'City of Bristol',
        'City of Buena Vista',
        'City of Charlottesville',
        'City of Chesapeake',
        'City of Colonial Heights',
        'City of Covington',
        'City of Danville',
        'City of Emporia',
        'City of Fairfax',
        'City of Falls Church',
        'City of Franklin',
        'City of Fredericksburg',
        'City of Galax',
        'City of Hampton',
        'City of Harrisonburg',
        'City of Hopewell',
        'City of Lexington',
        'City of Lynchburg',
        'City of Manassas',
        'City of Manassas Park',
        'City of Martinsville',
        'City of Newport News',
        'City of Norfolk',
        'City of Norton',
        'City of Petersburg',
        'City of Poquoson',
        'City of Portsmouth',
        'City of Radford',
        'City of Richmond',
        'City of Roanoke',
        'City of Salem',
        'City of Staunton',
        'City of Suffolk',
        'City of Virginia Beach',
        'City of Waynesboro',
        'City of Williamsburg',
        'City of Winchester'
    ],
    Washington: [
        'Adams',
        'Asotin',
        'Benton',
        'Chelan',
        'Clallam',
        'Clark',
        'Columbia',
        'Cowlitz',
        'Douglas',
        'Ferry',
        'Franklin',
        'Garfield',
        'Grant',
        'Grays Harbor',
        'Island',
        'Jefferson',
        'King',
        'Kitsap',
        'Kittitas',
        'Klickitat',
        'Lewis',
        'Lincoln',
        'Mason',
        'Okanogan',
        'Pacific',
        'Pend Oreille',
        'Pierce',
        'San Juan',
        'Skagit',
        'Skamania',
        'Snohomish',
        'Spokane',
        'Stevens',
        'Thurston',
        'Wahkiakum',
        'Walla Walla',
        'Whatcom',
        'Whitman',
        'Yakima'
    ],
    'West Virginia': [
        'Barbour',
        'Berkeley',
        'Boone',
        'Braxton',
        'Brooke',
        'Cabell',
        'Calhoun',
        'Clay',
        'Doddridge',
        'Fayette',
        'Gilmer',
        'Grant',
        'Greenbrier',
        'Hampshire',
        'Hancock',
        'Hardy',
        'Harrison',
        'Jackson',
        'Jefferson',
        'Kanawha',
        'Lewis',
        'Lincoln',
        'Logan',
        'McDowell',
        'Marion',
        'Marshall',
        'Mason',
        'Mercer',
        'Mineral',
        'Mingo',
        'Monongalia',
        'Monroe',
        'Morgan',
        'Nicholas',
        'Ohio',
        'Pendleton',
        'Pleasants',
        'Pocahontas',
        'Preston',
        'Putnam',
        'Raleigh',
        'Randolph',
        'Ritchie',
        'Roane',
        'Summers',
        'Taylor',
        'Tucker',
        'Tyler',
        'Upshur',
        'Wayne',
        'Webster',
        'Wetzel',
        'Wirt',
        'Wood',
        'Wyoming'
    ],
    Wisconsin: [
        'Adams',
        'Ashland',
        'Barron',
        'Bayfield',
        'Brown',
        'Buffalo',
        'Burnett',
        'Calumet',
        'Chippewa',
        'Clark',
        'Columbia',
        'Crawford',
        'Dane',
        'Dodge',
        'Door',
        'Douglas',
        'Dunn',
        'Eau Claire',
        'Florence',
        'Fond du Lac',
        'Forest',
        'Grant',
        'Green',
        'Green Lake',
        'Iowa',
        'Iron',
        'Jackson',
        'Jefferson',
        'Juneau',
        'Kenosha',
        'Kewaunee',
        'La Crosse',
        'Lafayette',
        'Langlade',
        'Lincoln',
        'Manitowoc',
        'Marathon',
        'Marinette',
        'Marquette',
        'Menominee',
        'Milwaukee',
        'Monroe',
        'Oconto',
        'Oneida',
        'Outagamie',
        'Ozaukee',
        'Pepin',
        'Pierce',
        'Polk',
        'Portage',
        'Price',
        'Racine',
        'Richland',
        'Rock',
        'Rusk',
        'St. Croix',
        'Sauk',
        'Sawyer',
        'Shawano',
        'Sheboygan',
        'Taylor',
        'Trempealeau',
        'Vernon',
        'Vilas',
        'Walworth',
        'Washburn',
        'Washington',
        'Waukesha',
        'Waupaca',
        'Waushara',
        'Winnebago',
        'Wood'
    ],
    Wyoming: [
        'Albany',
        'Big Horn',
        'Campbell',
        'Carbon',
        'Converse',
        'Crook',
        'Fremont',
        'Goshen',
        'Hot Springs',
        'Johnson',
        'Laramie',
        'Lincoln',
        'Natrona',
        'Niobrara',
        'Park',
        'Platte',
        'Sheridan',
        'Sublette',
        'Sweetwater',
        'Teton',
        'Uinta',
        'Washakie',
        'Weston'
    ]
};

export const Nationalities = [
    {
        id: 'afghan',
        name: 'Afghan'
    },
    {
        id: 'albanian',
        name: 'Albanian'
    },
    {
        id: 'algerian',
        name: 'Algerian'
    },
    {
        id: 'american',
        name: 'American'
    },
    {
        id: 'andorran',
        name: 'Andorran'
    },
    {
        id: 'angolan',
        name: 'Angolan'
    },
    {
        id: 'antiguans',
        name: 'Antiguans'
    },
    {
        id: 'argentinean',
        name: 'Argentinean'
    },
    {
        id: 'armenian',
        name: 'Armenian'
    },
    {
        id: 'australian',
        name: 'Australian'
    },
    {
        id: 'austrian',
        name: 'Austrian'
    },
    {
        id: 'azerbaijani',
        name: 'Azerbaijani'
    },
    {
        id: 'bahamian',
        name: 'Bahamian'
    },
    {
        id: 'bahraini',
        name: 'Bahraini'
    },
    {
        id: 'bangladeshi',
        name: 'Bangladeshi'
    },
    {
        id: 'barbadian',
        name: 'Barbadian'
    },
    {
        id: 'barbudans',
        name: 'Barbudans'
    },
    {
        id: 'batswana',
        name: 'Batswana'
    },
    {
        id: 'belarusian',
        name: 'Belarusian'
    },
    {
        id: 'belgian',
        name: 'Belgian'
    },
    {
        id: 'belizean',
        name: 'Belizean'
    },
    {
        id: 'beninese',
        name: 'Beninese'
    },
    {
        id: 'bhutanese',
        name: 'Bhutanese'
    },
    {
        id: 'bolivian',
        name: 'Bolivian'
    },
    {
        id: 'bosnian',
        name: 'Bosnian'
    },
    {
        id: 'brazilian',
        name: 'Brazilian'
    },
    {
        id: 'british',
        name: 'British'
    },
    {
        id: 'bruneian',
        name: 'Bruneian'
    },
    {
        id: 'bulgarian',
        name: 'Bulgarian'
    },
    {
        id: 'burkinabe',
        name: 'Burkinabe'
    },
    {
        id: 'burmese',
        name: 'Burmese'
    },
    {
        id: 'burundian',
        name: 'Burundian'
    },
    {
        id: 'cambodian',
        name: 'Cambodian'
    },
    {
        id: 'cameroonian',
        name: 'Cameroonian'
    },
    {
        id: 'canadian',
        name: 'Canadian'
    },
    {
        id: 'cape verdean',
        name: 'Cape Verdean'
    },
    {
        id: 'central african',
        name: 'Central African'
    },
    {
        id: 'chadian',
        name: 'Chadian'
    },
    {
        id: 'chilean',
        name: 'Chilean'
    },
    {
        id: 'chinese',
        name: 'Chinese'
    },
    {
        id: 'colombian',
        name: 'Colombian'
    },
    {
        id: 'comoran',
        name: 'Comoran'
    },
    {
        id: 'congolese',
        name: 'Congolese'
    },
    {
        id: 'costa rican',
        name: 'Costa Rican'
    },
    {
        id: 'croatian',
        name: 'Croatian'
    },
    {
        id: 'cuban',
        name: 'Cuban'
    },
    {
        id: 'cypriot',
        name: 'Cypriot'
    },
    {
        id: 'czech',
        name: 'Czech'
    },
    {
        id: 'danish',
        name: 'Danish'
    },
    {
        id: 'djibouti',
        name: 'Djibouti'
    },
    {
        id: 'dominican',
        name: 'Dominican'
    },
    {
        id: 'dutch',
        name: 'Dutch'
    },
    {
        id: 'east timorese',
        name: 'East Timorese'
    },
    {
        id: 'ecuadorean',
        name: 'Ecuadorean'
    },
    {
        id: 'egyptian',
        name: 'Egyptian'
    },
    {
        id: 'emirian',
        name: 'Emirian'
    },
    {
        id: 'equatorial guinean',
        name: 'Equatorial Guinean'
    },
    {
        id: 'eritrean',
        name: 'Eritrean'
    },
    {
        id: 'estonian',
        name: 'Estonian'
    },
    {
        id: 'ethiopian',
        name: 'Ethiopian'
    },
    {
        id: 'fijian',
        name: 'Fijian'
    },
    {
        id: 'filipino',
        name: 'Filipino'
    },
    {
        id: 'finnish',
        name: 'Finnish'
    },
    {
        id: 'french',
        name: 'French'
    },
    {
        id: 'gabonese',
        name: 'Gabonese'
    },
    {
        id: 'gambian',
        name: 'Gambian'
    },
    {
        id: 'georgian',
        name: 'Georgian'
    },
    {
        id: 'german',
        name: 'German'
    },
    {
        id: 'ghanaian',
        name: 'Ghanaian'
    },
    {
        id: 'greek',
        name: 'Greek'
    },
    {
        id: 'grenadian',
        name: 'Grenadian'
    },
    {
        id: 'guatemalan',
        name: 'Guatemalan'
    },
    {
        id: 'guinea-bissauan',
        name: 'Guinea-Bissauan'
    },
    {
        id: 'guinean',
        name: 'Guinean'
    },
    {
        id: 'guyanese',
        name: 'Guyanese'
    },
    {
        id: 'haitian',
        name: 'Haitian'
    },
    {
        id: 'herzegovinian',
        name: 'Herzegovinian'
    },
    {
        id: 'honduran',
        name: 'Honduran'
    },
    {
        id: 'hungarian',
        name: 'Hungarian'
    },
    {
        id: 'i-kiribati',
        name: 'I-Kiribati'
    },
    {
        id: 'icelander',
        name: 'Icelander'
    },
    {
        id: 'indian',
        name: 'Indian'
    },
    {
        id: 'indonesian',
        name: 'Indonesian'
    },
    {
        id: 'iranian',
        name: 'Iranian'
    },
    {
        id: 'iraqi',
        name: 'Iraqi'
    },
    {
        id: 'irish',
        name: 'Irish'
    },
    {
        id: 'israeli',
        name: 'Israeli'
    },
    {
        id: 'italian',
        name: 'Italian'
    },
    {
        id: 'ivorian',
        name: 'Ivorian'
    },
    {
        id: 'jamaican',
        name: 'Jamaican'
    },
    {
        id: 'japanese',
        name: 'Japanese'
    },
    {
        id: 'jordanian',
        name: 'Jordanian'
    },
    {
        id: 'kazakhstani',
        name: 'Kazakhstani'
    },
    {
        id: 'kenyan',
        name: 'Kenyan'
    },
    {
        id: 'kittian and nevisian',
        name: 'Kittian and Nevisian'
    },
    {
        id: 'kuwaiti',
        name: 'Kuwaiti'
    },
    {
        id: 'kyrgyz',
        name: 'Kyrgyz'
    },
    {
        id: 'laotian',
        name: 'Laotian'
    },
    {
        id: 'latvian',
        name: 'Latvian'
    },
    {
        id: 'lebanese',
        name: 'Lebanese'
    },
    {
        id: 'liberian',
        name: 'Liberian'
    },
    {
        id: 'libyan',
        name: 'Libyan'
    },
    {
        id: 'liechtensteiner',
        name: 'Liechtensteiner'
    },
    {
        id: 'lithuanian',
        name: 'Lithuanian'
    },
    {
        id: 'luxembourger',
        name: 'Luxembourger'
    },
    {
        id: 'macedonian',
        name: 'Macedonian'
    },
    {
        id: 'malagasy',
        name: 'Malagasy'
    },
    {
        id: 'malawian',
        name: 'Malawian'
    },
    {
        id: 'malaysian',
        name: 'Malaysian'
    },
    {
        id: 'maldivian',
        name: 'Maldivian'
    },
    {
        id: 'malian',
        name: 'Malian'
    },
    {
        id: 'maltese',
        name: 'Maltese'
    },
    {
        id: 'marshallese',
        name: 'Marshallese'
    },
    {
        id: 'mauritanian',
        name: 'Mauritanian'
    },
    {
        id: 'mauritian',
        name: 'Mauritian'
    },
    {
        id: 'mexican',
        name: 'Mexican'
    },
    {
        id: 'micronesian',
        name: 'Micronesian'
    },
    {
        id: 'moldovan',
        name: 'Moldovan'
    },
    {
        id: 'monacan',
        name: 'Monacan'
    },
    {
        id: 'mongolian',
        name: 'Mongolian'
    },
    {
        id: 'montenegrin',
        name: 'Montenegrin'
    },
    {
        id: 'moroccan',
        name: 'Moroccan'
    },
    {
        id: 'mosotho',
        name: 'Mosotho'
    },
    {
        id: 'motswana',
        name: 'Motswana'
    },
    {
        id: 'mozambican',
        name: 'Mozambican'
    },
    {
        id: 'namibian',
        name: 'Namibian'
    },
    {
        id: 'nauruan',
        name: 'Nauruan'
    },
    {
        id: 'nepalese',
        name: 'Nepalese'
    },
    {
        id: 'new zealander',
        name: 'New Zealander'
    },
    {
        id: 'ni-vanuatu',
        name: 'Ni-Vanuatu'
    },
    {
        id: 'nicaraguan',
        name: 'Nicaraguan'
    },
    {
        id: 'nigerian',
        name: 'Nigerian'
    },
    {
        id: 'nigerien',
        name: 'Nigerien'
    },
    {
        id: 'north korean',
        name: 'North Korean'
    },
    {
        id: 'northern irish',
        name: 'Northern Irish'
    },
    {
        id: 'norwegian',
        name: 'Norwegian'
    },
    {
        id: 'omani',
        name: 'Omani'
    },
    {
        id: 'pakistani',
        name: 'Pakistani'
    },
    {
        id: 'palauan',
        name: 'Palauan'
    },
    {
        id: 'panamanian',
        name: 'Panamanian'
    },
    {
        id: 'papua new guinean',
        name: 'Papua New Guinean'
    },
    {
        id: 'paraguayan',
        name: 'Paraguayan'
    },
    {
        id: 'peruvian',
        name: 'Peruvian'
    },
    {
        id: 'polish',
        name: 'Polish'
    },
    {
        id: 'portuguese',
        name: 'Portuguese'
    },
    {
        id: 'qatari',
        name: 'Qatari'
    },
    {
        id: 'romanian',
        name: 'Romanian'
    },
    {
        id: 'russian',
        name: 'Russian'
    },
    {
        id: 'rwandan',
        name: 'Rwandan'
    },
    {
        id: 'saint lucian',
        name: 'Saint Lucian'
    },
    {
        id: 'salvadoran',
        name: 'Salvadoran'
    },
    {
        id: 'samoan',
        name: 'Samoan'
    },
    {
        id: 'san marinese',
        name: 'San Marinese'
    },
    {
        id: 'sao tomean',
        name: 'Sao Tomean'
    },
    {
        id: 'saudi',
        name: 'Saudi'
    },
    {
        id: 'scottish',
        name: 'Scottish'
    },
    {
        id: 'senegalese',
        name: 'Senegalese'
    },
    {
        id: 'serbian',
        name: 'Serbian'
    },
    {
        id: 'seychellois',
        name: 'Seychellois'
    },
    {
        id: 'sierra leonean',
        name: 'Sierra Leonean'
    },
    {
        id: 'singaporean',
        name: 'Singaporean'
    },
    {
        id: 'slovakian',
        name: 'Slovakian'
    },
    {
        id: 'slovenian',
        name: 'Slovenian'
    },
    {
        id: 'solomon islander',
        name: 'Solomon Islander'
    },
    {
        id: 'somali',
        name: 'Somali'
    },
    {
        id: 'south african',
        name: 'South African'
    },
    {
        id: 'south korean',
        name: 'South Korean'
    },
    {
        id: 'spanish',
        name: 'Spanish'
    },
    {
        id: 'sri lankan',
        name: 'Sri Lankan'
    },
    {
        id: 'sudanese',
        name: 'Sudanese'
    },
    {
        id: 'surinamer',
        name: 'Surinamer'
    },
    {
        id: 'swazi',
        name: 'Swazi'
    },
    {
        id: 'swedish',
        name: 'Swedish'
    },
    {
        id: 'swiss',
        name: 'Swiss'
    },
    {
        id: 'syrian',
        name: 'Syrian'
    },
    {
        id: 'taiwanese',
        name: 'Taiwanese'
    },
    {
        id: 'tajik',
        name: 'Tajik'
    },
    {
        id: 'tanzanian',
        name: 'Tanzanian'
    },
    {
        id: 'thai',
        name: 'Thai'
    },
    {
        id: 'togolese',
        name: 'Togolese'
    },
    {
        id: 'tongan',
        name: 'Tongan'
    },
    {
        id: 'trinidadian or tobagonian',
        name: 'Trinidadian or Tobagonian'
    },
    {
        id: 'tunisian',
        name: 'Tunisian'
    },
    {
        id: 'turkish',
        name: 'Turkish'
    },
    {
        id: 'tuvaluan',
        name: 'Tuvaluan'
    },
    {
        id: 'ugandan',
        name: 'Ugandan'
    },
    {
        id: 'ukrainian',
        name: 'Ukrainian'
    },
    {
        id: 'uruguayan',
        name: 'Uruguayan'
    },
    {
        id: 'uzbekistani',
        name: 'Uzbekistani'
    },
    {
        id: 'venezuelan',
        name: 'Venezuelan'
    },
    {
        id: 'vietnamese',
        name: 'Vietnamese'
    },
    {
        id: 'welsh',
        name: 'Welsh'
    },
    {
        id: 'yemenite',
        name: 'Yemenite'
    },
    {
        id: 'zambian',
        name: 'Zambian'
    },
    {
        id: 'zimbabwean',
        name: 'Zimbabwean'
    }
];
